import {VueController} from '@/service/support/vuex-controller';
import vaultService from '@/service/vault-service';
import JSZip from "jszip";
import FileSaver from "file-saver";
import * as awsVars from '../config/aws-exports';
import moment from "moment";
import uuid from 'uuid';
import toMaterialStyle from 'material-color-hash';
import {EventBus} from "@/service/support/event-bus";
import Auth from "@aws-amplify/auth";
import 'video.js/dist/video-js.css';
import { videoPlayer } from 'vue-video-player';
import "vue-pdf-app/dist/icons/main.css";
import WebViewer from '../components/WebViewer.vue'
import VTextFieldAsync from "../components/VTextFieldAsync";
import WorkflowTimeline from "../components/WorkflowTimeline.vue";
import { VueEditor } from "vue2-editor";
import variables from '../assets/scss/_variables.scss';
import ShieldSpinner from "../components/ShieldSpinner.vue";

let awsmobile = awsVars.default(process.env);
const ALLOWED_FILETYPES = ['png', 'jpg', 'jpeg', 'bmp', 'tiff', 'pdf', 'gif', 'docx', 'pptx', 'xlsx'];

export default VueController("Portal", {
	components: {
		WebViewer,
		videoPlayer,
		VTextFieldAsync,
		VueEditor,
		WorkflowTimeline,
		ShieldSpinner
	},
	data() {
		return {
			variables,
			publicPath : process.env.BASE_URL,
			tab: null,
			value: 1,
			viewMode: 0,
			filesSortBy: "name",
			filesSortDesc: false,
			taskViewMode: 0,
			taskDueDateMenu: false,
			numRecentLoaded: 50,
			taskDueDateEditMenu: false,
			originalVaultName: "",
			recentActivityViewMode: 0,
			showPermissionDetails: false,
			pdfViewerFormDirty: false,
			vaultTokenLoaded: false,
			lastTaskIdFromUpload: null,
			showingDeleted: false,
			invitationLoading: false,
			vaultNameEditing: false,
			showRecentPanel: false,
			userVaultPermissions: {
				view_files: false,
				upload_files: false,
				rename_files: false,
				delete_files: false,
				manage_perms: false,
				create_vault: false,
				access_vault: false
			},
			selectedNotificationEmails: [],
			defaultNotificationEmailMessage: `<p>The following files have been recently uploaded to the Portal "{{portalName}}".</p><p>{{selectedFiles}}</p>Please visit your portal to download these files here: <a href="{{portalUrl}}">{{portalUrl}}</a><p>`,
			defaultTaskNotificationEmailMessage: `<p>Please complete the following tasks for Portal "{{portalName}}".</p><p>{{openTasks}}</p>Please visit your portal to review and complete these tasks here: <a href="{{portalUrl}}">{{portalUrl}}</a><p>`,
			newNotificationEmailMessage: "",
			editedEmailMessage: "",
			composeNotificationTab: 0,
			composerEmail: [
				['bold', 'italic', 'underline', 'strike'],        // toggled buttons
				[{ 'header': 1 }],               // custom button values
				[{ 'list': 'ordered'}, { 'list': 'bullet' }],
				[{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
				[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
				[{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
				[{ 'align': [] }],
				['clean']                                         // remove formatting button
			],
			memberVaultPerms: [],
			auditFilterSelection: ['Invite Guest','Portal Terms Accepted','Download','Upload','Copy','Move','Rename','Delete', 'PDF Form Filled', 'PDF Signed', 'File Comment'],
			newFolderName: "",
			tokenRefreshTimer: null,
			recentActivitySelected: {},
			fileRefreshTimer: null,
			currentFolderFile: null,
			copyFileMode: false,
			taskDateMenu: false,
			filePreviewMode: false,
			filePreviewImage: null,
			selectedFileToPreview: null,
			selectedPreviewFileUrl: null,
			selectedFileUrlTarget: null,
			selectedPreviewFileText: "",
			selectedPreviewFileUrlXfdf: null,
			selectedFileToPreviewIndex: 0,
			loadingSave: false,
			previewToolMode: "none",
			videoPlayerOptions: {
				language: 'en',
				playbackRates: [0.7, 1.0, 1.5, 2.0],
				height: 600,
				sources: [],
				autoplay: true,
				fluid: true,
				muted: true
			},
			selectedTreeFolder: [],
			open: ['public'],
			files: {
				html: 'mdi-language-html5',
				js: 'mdi-nodejs',
				json: 'mdi-code-json',
				md: 'mdi-language-markdown',
				pdf: 'mdi-file-pdf',
				png: 'mdi-file-image',
				txt: 'mdi-file-document-outline',
				xls: 'mdi-file-excel',
			},
			invitees: [
				{
					email: '',
					name: ''
				}
			],
			breadcrumbs: [{
				name: "Home Folder",
				id: null
			}],
			currentDirectory: '/',
			queuePaused: true,
			displayFilesForPath: [],
			vaultFiles: [],
			selectedFiles: [],
			innerDragFiles: [],
			isInnerDragging: false,
			comments: {},
			perms: [],
			logoBucket: null,
			snackBar: false,
			snackBarType: "",
			snackBarNotify: "",
			vault: null,
			vaultToken: null,
			vaultTasks: [],
			taskCalendarFocus: '',
			colors: ['blue', 'indigo', 'deep-purple', 'cyan', 'green', 'orange', 'grey darken-1'],
			taskDueDates: [],
			thumbBucket: null,
			mobileActionsMenu: {
				items: [
					{title: 'Click Me'},
					{title: 'Click Me'},
					{title: 'Click Me'},
					{title: 'Click Me 2'},
				],
				disabled: false,
				absolute: false,
				openOnHover: false,
				value: false,
				closeOnClick: true,
				closeOnContentClick: true,
				offsetX: false,
				offsetY: true,
			},
			isDragging: false,
			uploadRunnerTimer: null,
			auditHistory: [],
			uploadInProgress: false,
			permissionHeaders: [
				{text: "Name", align: 'start', sortable: true, value: 'user_name', width: "160px"},
				{text: "Email", value: 'user_email'},
				{text: "Access Portal", value: "access_vault", width: "60px", sortable: false},
				{text: "View Files", value: "view_files", width: "60px", sortable: false},
				{text: "Rename Files", value: "rename_files", width: "60px", sortable: false},
				{text: "Delete Files", value: "delete_files", width: "60px", sortable: false},
				{text: "Upload Files", value: "upload_files", width: "60px", sortable: false},
				{text: "Upload Notifications", value: "upload_notification", width: "80px", sortable: false},
				{text: "Download Notifications", value: "download_notification", width: "80px", sortable: false},
				{text: "Invitation", value: "invitation_accepted", width: "170px", sortable: false}
			],
			mainTaskHeaders: [
				{text: "Completed", sortable: true, value: 'status', width: "1%"},
				{text: "Task Name", sortable: true, value: 'name', width: "120px"},
				{text: "Due Date", value: 'due_date', width: "120px", sort: this.tasksFullTableSort},
			],
			taskTabHeaders: [
				{text: "Completed", sortable: true, value: 'status', width: "1%"},
				{text: "Task Name", sortable: true, value: 'name'},
				{text: "Client Response", value: 'clientResponse', width: "200px"},
				{text: "Attached Files", value:'attached_files',width:"200px"},
				{text: "Due Date", value: 'due_date', width: "120px", sort: this.tasksFullTableSort},
			],
			auditHistoryHeaders: [
				{text: "Date", align: 'start', sortable: true, value: 'action_date', width: "120px"},
				{text: "User", value: "username"},
				{text: "Action", value: 'action',
					filter: value => {
						return this.auditFilterSelection.indexOf(value) > -1;
					}
				},
				{text: "File", value: "filename", width: "220px"}
			],
			modals: {
				inviteGuests: false,
				manageGuestPerms: false,
				createFolder: false,
				createTask: false,
				renameFile: false,
				moveFile: false,
				auditHistory: false,
				deleteConfirmation: false,
				recentActivity: false
			},
			progress: {
				deleteConfirmation: false,
				inviteGuests: false,
				manageGuestPerms: false,
				createFolder: false,
				createTask: false,
				renameFile: false,
				moveFile: false,
				auditHistory: false,
				resendInvitation: false,
				recentActivity: false,
				recentActivitySending: false,
				recentActivityDownloading: false
			},
			renameFilenameValue: "",
			fileCopyMode: false,
			fileCopyMoveDestination: "",
			fileSearch: "",
			loadingFiles: true,
			termsDialog: false,
			termsAndConditions: "",
			newTask: {
				title: "",
				description: "",
				due_date_formatted: "",
				due_date: null,
				status: "Open"
			},
			newTaskTitleRules: [v => !!v || 'This field is required'],
			newComment: "",
			auditTablePage: 1,
			auditTablePageCount: 0,
			auditTableItemsPerPage: 500,
			filesTablePage: 1,
			filesTablePageCount: 0,
			filesTableItemsPerPage: 100,
			
			// File Accumulator properties
			fileAccumulator: {
				isVisible: false,
				isMinimized: false,
				recentFiles: [],
				customMessage: "",
				subject: "",
				selectedEmails: [],
				autoShow: true,
				lastClosedTimestamp: null,
				sending: false
			},
			// Messages tab data
			messages: [],
			messagesLoaded: false,
			canLoadMoreMessages: false,
			loadingMoreMessages: false,
			messagesPage: 1,
			messagesPerPage: 50
		};
	},
	state: [
		'vaults',
		'user',
		"organization",
		'organizationId',
		"downloadProgress",
		'cognito',
		'pageIsLoading',
		'dialogs',
		'embeddedFullScreen',
		'uploadFileQueue',
		'currentUploadRequest'
	],
	beforeDestroy() {
		let self = this;

		document.removeEventListener("fileDragging", self.fileDraggingEventHandler);
		document.removeEventListener("fileLeaving", self.fileLeavingEventHandler);
		document.removeEventListener("fileDropped", self.fileDroppedEventHandler);
		document.removeEventListener("fileDownloaded", self.fileDownloadedEventHandler);
		if (self._visibilityHandler) {
			document.removeEventListener("visibilitychange", self._visibilityHandler);
			self._visibilityHandler = null;
		}
		//console.log(`Vault ${self.vault.id} before destroy.`);

		if (this.uploadRunnerTimer) {
			clearInterval(this.uploadRunnerTimer);
		}

		if (this.tokenRefreshTimer) {
			clearInterval(this.tokenRefreshTimer);
		}

		if (this.fileRefreshTimer) {
			clearInterval(this.fileRefreshTimer);
		}

		this.currentUploadRequest = null;
		this.uploadFileQueue = [];

		window.onpopstate = null;
	},
	created() {
		let self = this;

		window.onpopstate = function(e) {
			console.log("History: " + JSON.stringify(window.history));

			let folderId = window.location.pathname.substring(window.location.pathname.indexOf("/folder/")).replace("/folder/", "");
			console.log('EARL Changed to ' + folderId);
			self.currentFolderFile = folderId === "main" ? null : self.vaultFiles.filter(file => file.id === folderId);

			self.refreshFiles(true, false, folderId !== "main" ? folderId : null);
		};

		this.logoBucket = awsmobile.aws_org_logos_s3_bucket;
		//window.addEventListener("resize", this.resizePreview);
	},
	mounted() {
		let self = this;

		document.addEventListener("fileDragging", self.fileDraggingEventHandler);
		document.addEventListener("fileLeaving", self.fileLeavingEventHandler);
		document.addEventListener("fileDropped", self.fileDroppedEventHandler);
		document.addEventListener("fileDownloaded", self.fileDownloadedEventHandler);

		// Pause/resume the file-refresh polling when the tab visibility
		// changes. Avoids hammering AppSync/DynamoDB for portals open in
		// background tabs and immediately refreshes when the user returns.
		self._visibilityHandler = function() {
			if (document.hidden) {
				if (self.$data.fileRefreshTimer) {
					clearInterval(self.$data.fileRefreshTimer);
					self.$data.fileRefreshTimer = null;
				}
			} else if (!self.$data.fileRefreshTimer && self.userVaultPermissions && self.userVaultPermissions.view_files) {
				self.refreshFiles(true, false, undefined, undefined, true);
			}
		};
		document.addEventListener("visibilitychange", self._visibilityHandler);
		//console.log("Vault activated");


		if (this.$route.params.folderid === "main") {
			self.currentFolderFile = null;
		}
		if (self.$route.query.embedded === "true" || self.$route.query.embedded === true) {
			self.embeddedFullScreen = true;
		}

		this.logoBucket = awsmobile.aws_org_logos_s3_bucket;
		let placeholderFiles = [
			{
				name: "placeholder",
				id: -1,
				extension: "nnn",
				_lastChangedAt: 0,
				modified_by_name: '',
				modified_by_email: '',
				size: 0,
				placeholder: true,
				comments: []
			},
			{
				name: "placeholder",
				id: -2,
				extension: "nnn",
				_lastChangedAt: 0,
				modified_by_name: '',
				modified_by_email: '',
				size: 0,
				placeholder: true,
				comments: []
			},
			{
				name: "placeholder",
				id: -3,
				extension: "nnn",
				_lastChangedAt: 0,
				modified_by_name: '',
				modified_by_email: '',
				size: 0,
				placeholder: true,
				comments: []
			}
		];
		this.auditHistory = [];
		this.vaultFiles = placeholderFiles;
		this.displayFilesForPath = placeholderFiles;
		this.doubleCheckUploadStatus();

		this.loadVault();
	},
	computed: {

		officeViewerUrl(){
			return this.selectedPreviewFileUrl ? this.selectedPreviewFileUrl : null;
		},
		userTypeVisibility(){
			let self = this;
			let isVisible = false;
			if (self.cognito) {
				switch (self.cognito.attributes["custom:mutableUserType"]) {
					case "admin": {
						if (this.organization.permissions.find(perm => perm['manage_perms'] === true && perm.user_id === this.user.id && perm._deleted !== 1)) {
							isVisible = true;
						} else {
							isVisible = false;
						}
						break;
					}
					case "member": {
						if (self.userHasPermission('manage_perms')) {
							isVisible = true;
						} else if (!self.vault || self.vault.hide_perms) {
							isVisible = false;
						}
						break;
					}
					case "guest": {
						if (!self.vault || self.vault.hide_perms) {
							isVisible = false;
						} else {
							isVisible = true;
						}
						break;
					}
					default : {
						console.log("UserType not found defaulting to false");
						isVisible = false;
					}
				}
			}
			return isVisible;
		},
		vaultTasksFiltered() {
			return this.$data.vaultTasks;
			//return this.$data.vaultTasks.filter(task => task._deleted !== 1);
		},
		numberOfOpenTasks() {
			return this.$data.vaultTasks.filter(task => task.status !== "Done" && task._deleted !== 1).length;
		},
		numberOfDoneTasks() {
			return this.vaultTasks.filter(task => task.status === "Done" && task._deleted !== 1).length;
		},
		earliestTaskDate() {
			let self = this;
			let openDates = self.$data.vaultTasks.filter(task => task.status !== "Done" && task._deleted !== 1 && task.due_date);
			let earliestDate = -1;

			for (let i = 0; i < openDates.length; i++) {
				if (earliestDate < 0) {
					earliestDate = openDates[i].due_date;
				} else {
					let dueDate = moment(openDates[i].due_date);
					if (dueDate < moment(earliestDate)) {
						earliestDate = openDates[i].due_date;
					}
				}
			}

			return earliestDate;
		},
		uploadEmailAddresses() {
			let notificationEmails = [];
			if (this.vault && this.vault.permissions) {
				for (let i = 0; i < this.vault.permissions.length; i++) {
					let perm = this.vault.permissions[i];

					// Only include members who are not deleted AND have accepted their invitation
					if (perm._deleted !== 1 && perm.invitation_accepted === "true") {
						notificationEmails.push({
							email: perm.user_email,
							name: `${perm.user_name} <${perm.user_email}>`
						});
					}
				}
			}
			return notificationEmails;
		},
		renderedNotificationMessage() {
			let updatedValue = this.newNotificationEmailMessage;

			let selectedFilesListHtml = "";
			if (updatedValue.indexOf('selectedFiles') > -1 && this.recentActivityHasFileSelected) {
				for (let fileId in this.recentActivitySelected) {
					if (this.recentActivitySelected[fileId] === true) {
						let recentSelectedFile = this.vaultFiles.find(tmpFile => tmpFile.id === fileId);
						if (recentSelectedFile) {
							selectedFilesListHtml += `<li>${recentSelectedFile.name}</li>`;
						}
					}
				}

				if (selectedFilesListHtml) {
					selectedFilesListHtml = '<ul>' + selectedFilesListHtml + "</ul>";
				}
			}

			let openTaskHtml = "";
			let doneTaskHtml = "";
			for (let v = 0; v < this.vaultTasks.length; v++) {
				let task = this.vaultTasks[v];
				if (task._deleted !== 1) {
					if (task.status === "Open") {
						openTaskHtml += `<li>${task.title}</li>`;
					} else if (task.status === "Done") {
						doneTaskHtml += `<li>${task.title}</li>`;
					}
				}
			}

			if (openTaskHtml) {
				openTaskHtml = '<ul>' + openTaskHtml + '</ul>';
			}

			if (doneTaskHtml) {
				doneTaskHtml = '<ul>' + doneTaskHtml + '</ul>';
			}

			let terms = [
				{ token: "orgName", value: this.organization ? this.organization.companyName : '' },
				{ token: "userName", value: this.user ? this.user.displayName : '' },
				{ token: "portalName", value: this.vault ? this.vault.name : '' },
				{ token: "portalUrl", value: window.location.href },
				{ token: "selectedFiles", value: selectedFilesListHtml },
				{ token: "openTasks", value: openTaskHtml },
				{ token: "doneTasks", value: doneTaskHtml }
			];

			for (let i = 0; i < terms.length; i++) {
				let term = terms[i];
				updatedValue = updatedValue.replaceAll("{{" + term.token + "}}", term.value);
				updatedValue = updatedValue.replaceAll("{{ " + term.token + " }}", term.value);
			}
			return updatedValue;
		},
		fileAccumulatorPreviewMessage() {
			let messageHtml = '';
			
			// Add custom message if provided
			if (this.fileAccumulator.customMessage) {
				messageHtml += `<p>${this.fileAccumulator.customMessage}</p>`;
			}
			
			// Collect all files to include in the notification
			let completedUploadFiles = this.uploadFileQueue.filter(f => f.status === 'done').map(f => ({
				name: f.upload.filename,
				size: f.upload.size || 0
			}));
			
			let allCompletedFiles = [...this.fileAccumulator.recentFiles, ...completedUploadFiles];
			
			// Add file list first
			if (allCompletedFiles.length > 0) {
				messageHtml += '<ul>';
				allCompletedFiles.forEach(file => {
					messageHtml += `<li><strong>${file.name}</strong></li>`;
				});
				messageHtml += '</ul>';
			}
			
			// Add portal link
			messageHtml += `<p>Portal: <a href="${window.location.origin}${window.location.pathname}${window.location.search}">${this.vault ? this.vault.name : 'Portal'}</a></p>`;
			
			return messageHtml;
		},
		color () {
			switch (this.value) {
				case 0:
					return 'blue-grey'
				case 1:
					return 'teal'
				case 2:
					return 'brown'
				case 3:
					return 'indigo'
				default:
					return 'blue-grey'
			}
		},
		portalNotificationEmails() {
			return ["Bryan Stouffer <bstouffer@gmail.com>"]
		},
		recentActivityHasFileSelected() {
			let recentFileSelected = false;
			for (let x in this.recentActivitySelected) {
				if (this.recentActivitySelected.hasOwnProperty(x) && this.recentActivitySelected[x] === true) {
					recentFileSelected = true;
					break;
				}
			}
			return recentFileSelected;
		},
		numberUnreadFiles() {
			let self = this;
			let unreadFiles = self.vaultFiles.filter(file => (typeof file.uploaded_by_host !== 'undefined' || typeof file.downloaded_by_host !== 'undefined') && self.fileWasNotDownloaded(file));
			return unreadFiles.length;
		},
		allFilesSortedByDate() {
			//Only showing last 30 days
			let self = this;
			let now = new Date();
			return [...this.vaultFiles.sort( (a, b) => {
				let aDate = self.getLatestDate(a);
				let bDate = self.getLatestDate(b);
				//aDate = new Date(aDate);
				//bDate = new Date(bDate);
				//console.log(`aDate: ${aDate} - bDate: ${bDate} = ${aDate - bDate}`);

				return bDate - aDate;
			})]
				.filter(file => file.extension !== 'fld'); // && ((now.getTime() - self.getLatestDate(file)) < (86400000 * 30))

		},
		allFilesAndUploadsSortedByDate() {
			//Only showing last 30 days
			let self = this;
			let now = new Date();
			return [...this.vaultFiles.concat(this.uploadFileQueue).sort( (a, b) => {
				let aDate = self.getLatestDate(a);
				let bDate = self.getLatestDate(b);
				//aDate = new Date(aDate);
				//bDate = new Date(bDate);
				//console.log(`aDate: ${aDate} - bDate: ${bDate} = ${aDate - bDate}`);

				return bDate - aDate;
			})]
				.filter(file => file.extension !== 'fld'); // && ((now.getTime() - self.getLatestDate(file)) < (86400000 * 30))

		},
		todayYYmmddFormat() {
			let d = new Date();

			let month = '' + (d.getMonth() + 1);
			let day = '' + d.getDate();
			let year = d.getFullYear();
			if (month.length < 2)
				month = '0' + month;
			if (day.length < 2)
				day = '0' + day;

			return [year, month, day].join('');
		},
		allFilesGroupedByDateLoaded() {
			let partialList = [];
			let partialListCount = 0;

			for (let i = 0; i < this.allFilesGroupedByDate.length; i++) {
				let roomRemaining = this.numRecentLoaded - partialListCount;
				if (this.allFilesGroupedByDate[i].files.length >= roomRemaining) {
					let newGroup = {
						date: this.allFilesGroupedByDate[i].date,
						fieldId: this.allFilesGroupedByDate[i].fieldId
					};
					newGroup.files = this.allFilesGroupedByDate[i].files.slice(0, roomRemaining);
					partialList.push(newGroup);
					break;
				} else {
					partialListCount += this.allFilesGroupedByDate[i].files.length;
					partialList.push(this.allFilesGroupedByDate[i]);
				}
			}
			return partialList;
		},
		allFilesGroupedByDate() {
			//numRecentLoaded
			let now = new Date();
			let dateYYmmddFormat = function(d) {
				let month = '' + (d.getMonth() + 1);
				let day = '' + d.getDate();
				let year = d.getFullYear();
				if (month.length < 2)
					month = '0' + month;
				if (day.length < 2)
					day = '0' + day;

				return [year, month, day].join('');
			};
			let sortedFiles = this.allFilesAndUploadsSortedByDate;
			let dateMap = {};
			dateMap[dateYYmmddFormat(now)] = {
				files: [],
				date: now.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }),
				fieldId: dateYYmmddFormat(now)
			};

			for (let sf = 0; sf < sortedFiles.length; sf++) {
				let d = new Date(parseInt(this.getLatestDate(sortedFiles[sf])));
				let fileDateString = dateYYmmddFormat(d);
				if (sortedFiles[sf]._deleted !== 1) {
					if (!dateMap.hasOwnProperty(fileDateString)) {
						dateMap[fileDateString] = {
							files: [],
							date: d.toLocaleDateString('en-US', { year: 'numeric', month: 'short', day: 'numeric' }),
							fieldId: fileDateString
						};
					}
					dateMap[fileDateString].files.push(sortedFiles[sf]);
				}
			}
			let dateMapArray = [];
			for (let dmKey in dateMap) {
				if (dateMap.hasOwnProperty(dmKey)) {
					dateMapArray.unshift(dateMap[dmKey]);
				}
			}
			return dateMapArray;
		},
		imagePreviewArray() {
			return self.filePreviewImage ? [self.filePreviewImage] : [];
		},
		oneSelection() {
			return this.selectedFiles && this.selectedFiles.length === 1;
		},
		oneFileSelection() {
			return this.selectedFiles && this.selectedFiles.length === 1 && this.selectedFiles[0].extension !== "fld";
		},
		vaultBelongsToUserOrg() {
			return this.vault && this.user && this.user.memberOf === this.vault.org_id;
		},
		mobileAndTabletCheck() {
			let check = false;
			(function(a) {
				if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4))) check = true;
			})(navigator.userAgent || navigator.vendor || window.opera);
			return check;
		},
		currentFolderTree() {
			let self = this;

			//DONE: Mark any selected folder as disabled.
			//DONE: Only show current directory and below.

			let getFoldersInFolder = function(folder) {
				let folderItem = {
					id: folder.id,
					name: folder.name,
					locked: !!self.selectedFiles.find(file => file.id === folder.id)
				};
				let subFolders = self.vaultFiles.filter(file => file.extension === "fld" && file._deleted !== 1 && file.parent_folder_file_id === folder.id);
				if (subFolders && subFolders.length > 0 && !folderItem.locked) {
					folderItem.children = subFolders.map(subFolder => {
						return {
							id: subFolder.id,
							name: subFolder.name,
							locked: !!self.selectedFiles.find(file => file.id === subFolder.id)
						};
					});
					for (let i = 0; i < subFolders.length; i++) {
						getFoldersInFolder(subFolders[i]);
					}
				}
				return folderItem;
			};

			let folderTreeBuilder = [];
			let tmpRootChildren = [];
			let rootFolders = self.vaultFiles.filter(file => file.extension === "fld" && file._deleted !== 1 && !file.parent_folder_file_id);
			for (let f = 0; f < rootFolders.length; f++) {
				let folder = rootFolders[f];
				let folderItem = getFoldersInFolder(folder);
				tmpRootChildren.push(folderItem);
			}
			folderTreeBuilder.push({
				name: "Home Folder",
				id: -1,
				locked: false,
				children: tmpRootChildren,
				open: true
			});

			return folderTreeBuilder;
		},
		responsiveFileHeaderLayout() {
			let breakpointName = this.$vuetify.breakpoint.name;
			if (this.viewMode === 1) {
				if (breakpointName !== "xs" || breakpointName !== "sm") {
					breakpointName = "md";
				} else if (breakpointName === "md") {
					breakpointName = "sm";
				}
			}
			switch (breakpointName) {
				case 'xs':
				case 'sm':
					return [
						{text: "Name", value: "name", sortable: true, align: 'start', width: "100%"}
					];
				case 'md':
					return [
						{text: "Name", value: "name", sortable: true, align: 'start', width: "190px"},
						{text: "Date Modified", value: "_lastChangedAt", sortable: true, width: "100px"},
						{text: "Notes", value: "comments", width: "200px"}
					];
				case 'lg':
					return [
						{text: "Name", value: "name", sortable: true, align: 'start', width: "50%"},
						{text: "Date Modified", value: "_lastChangedAt", sortable: true, width: "170px"},
						{text: "Size", value: "size", sortable: true, width: "100px"},
						{text: "Notes", value: "comments", width: "300px"}
					];
				default:
					return [
						{text: "Name", value: "name", sortable: true, align: 'start', width: "60%"},
						{text: "Date Modified", value: "_lastChangedAt", sortable: true, width: "170px"},
						{text: "Type", value: "extension", sortable: true, width: "150px"},
						{text: "Size", value: "size", sortable: true, width: "100px"},
						{text: "Notes", value: "comments", width: "300px"}
					];
			}
		},
		filteredFilesOnSearchAndDelete() {
			let files = [];
			if (this.fileSearch) {
				files = this.vaultFiles.filter(item => this.filterFilesOnSearch(item.name, this.fileSearch, item));
			} else {
				files = this.displayFilesForCurrentDirectory;
			}

			return this.customSort(files, "name", false);
		},
		filteredFilesOnlyOnSearchAndDelete() {
			let files = this.filteredFilesOnSearchAndDelete.filter(item => item.extension !== 'fld');
			return this.customSort(files, "name", false);
		},
		filteredGuestPermissions() {
			if (this.vault) {
				return this.vault.permissions.filter(function(permissions) {
					return permissions.invitation_accepted.match(true) && permissions.user_type === 'guest' && permissions._deleted !== 1;
				});
			}
		},
		filteredPendingGuestPermissions() {
			if (this.vault) {
				return this.vault.permissions.filter(function(permissions) {
					return !permissions.invitation_accepted.match(true) && permissions.user_type === 'guest' && permissions._deleted !== 1;
				});
			}
		},
		activePermissions() {
			if (this.vault) {
				const permissions = this.vault.permissions.filter(permission => 
					permission._deleted !== 1
				);

				// Check if active user is a member/admin of the vault's organization
				const activeUserType = this.cognito && this.cognito.attributes ? 
									   this.cognito.attributes["custom:mutableUserType"] : 'guest';

				// User is considered staff if they belong to the org AND are admin/member
				const isOrgStaff = this.vaultBelongsToUserOrg && 
								   (activeUserType === 'admin' || activeUserType === 'member');

				if (isOrgStaff) {
					// Include all active permissions (guest, admin, member)
					return permissions;
				}

				// Otherwise (Guests/External), only show guests and self
				// This hides organization members/admins from guests
				return permissions.filter(permission => 
					permission.user_type === 'guest' || 
					(this.user && permission.user_id === this.user.id)
				);
			}
			return [];
		},
		
	// Workflow States computed properties
	workflowStateOptions() {
		// First try organization workflowStates (for admins/members)
		if (this.organization && this.organization.workflowStates && this.organization.workflowStates.length > 0) {
			return this.organization.workflowStates;
		}
		// Fallback to vault's orgWorkflowStates (for guests)
		if (this.vault && this.vault.orgWorkflowStates && this.vault.orgWorkflowStates.length > 0) {
			return this.vault.orgWorkflowStates;
		}
		return [];
	},
		
	currentWorkflowStateName() {
		// Return the workflow state name, looking it up from ID if necessary
		if (!this.vault) {
			return null;
		}
		
		// If we have the name stored directly, use it (but verify it's not orphaned)
		if (this.vault.workflowStateName && this.vault.workflowStateName !== 'Not Set') {
			// Check if this workflow state still exists in organization settings
			if (this.isCurrentWorkflowStateOrphaned) {
				return this.vault.workflowStateName + ' (Deleted)';
			}
			return this.vault.workflowStateName;
		}
		
		// Fall back to looking up the name from the ID
		// This ensures resilience when workflowStateName is missing but workflowStateId is present
		if (this.vault.workflowStateId && this.workflowStateOptions && this.workflowStateOptions.length > 0) {
			const state = this.workflowStateOptions.find(s => s.id === this.vault.workflowStateId);
			if (state && state.name) {
				return state.name;
			}
			// ID exists but state not found - it was deleted
			return 'Unknown State (Deleted)';
		}
		
		return null;
	},
		
		isCurrentWorkflowStateOrphaned() {
			if (!this.vault || !this.vault.workflowStateId || !this.organization || !this.organization.workflowStates) {
				return false;
			}
			
			// Check if the vault's workflowStateId exists in the organization's current workflow states
			const stateExists = this.organization.workflowStates.find(state => state.id === this.vault.workflowStateId);
			return !stateExists;
		},
		
		userCanEditWorkflow() {
			if (!this.cognito || !this.cognito.attributes) return false;
			
			const userType = this.cognito.attributes["custom:mutableUserType"];
			
			// Guests cannot edit workflow state
			if (userType === "guest") return false;
			
			// Admins and members can edit
			return userType === "admin" || userType === "member";
		},
		displayFilesForCurrentDirectory() {
			let filesInFolder = [];
			let folderFileId = this.currentFolderFile ? this.currentFolderFile.id : null;

			if (this.fileSearch) {
				filesInFolder = this.vaultFiles;
			} else {
				if (this.vaultFiles) {
					let tmpFiles =
						this.vaultFiles.filter(vf => vf.status !== "uploading")
							.concat(this.uploadFileQueue.filter(qf => qf.status !== "done"))
							.filter(file =>
								file.parent_folder_file_id === folderFileId ||
								(!folderFileId && !file.parent_folder_file_id)
							);
					if (tmpFiles) {
						filesInFolder = tmpFiles;
					}
				}
			}

		return filesInFolder;
	}
	},
	watch: {
		// Reset to page 1 when items per page changes
		filesTableItemsPerPage() {
			this.filesTablePage = 1;
		},
		auditTableItemsPerPage() {
			this.auditTablePage = 1;
		},
		// Reset viewMode if tier doesn't support tasks panel
		viewMode(newValue) {
			if (newValue === 1 && this.vault && this.vault.orgTier && this.vault.orgTier !== 'enterprise' && this.vault.orgTier !== 'large firm') {
				this.viewMode = 0;
			}
		},
		'vault.orgTier'() {
			// Reset viewMode if tier changes and doesn't support tasks
			if (this.viewMode === 1 && this.vault && this.vault.orgTier && this.vault.orgTier !== 'enterprise' && this.vault.orgTier !== 'large firm') {
				this.viewMode = 0;
			}
		}
	},
	methods: {
		loadMoreRecentFiles() {
			this.numRecentLoaded += 50;
		},
		fileDraggingEventHandler(event) { this.dragFile(event, true); },
		fileLeavingEventHandler(event) { this.dragFile(event, false); },
		fileDroppedEventHandler(event) { this.receiveFilesFromOutsideDrop(event); },
		fileDownloadedEventHandler(event) { this.downloadProgress.num_downloaded++; },
		startInnerDrag(event, item) {
			event.dataTransfer.dropEffect = 'copy';
			event.dataTransfer.effectAllowed = 'copy';
			if (this.selectedFiles && this.selectedFiles.length > 0) {
				this.innerDragFiles = this.selectedFiles;
			} else if (item) {
				this.innerDragFiles = [item];
			}
			this.isInnerDragging = true;
		},
		async receiveFilesFromBrowseInput(event) {
			if (event && event.target && event.target.files && event.target.files instanceof FileList) {
				//alert(JSON.stringify(event.target.file[0]));
				await this.processFilesForUpload(event.target.files, [], this.lastTaskIdFromUpload);
			} else {
				this.error("Invalid input type file event.");
			}
		},
		async receiveFilesFromOutsideDrop(event) {
			console.log("Files from outer drop.");
			let self = this;
			//Directories only happen during drag / drop.. get the files recursively, then push down
			if (event instanceof CustomEvent && event.type === "fileDropped") {
				if (event.detail.dataTransfer.files.length > 0) {
					let allEntries = await self.getAllFileEntries(event.detail.dataTransfer);
					try {
						await self.processFilesForUpload(allEntries.files, allEntries.directories)
						let currentTasks = document.querySelectorAll(".task-drop-item");
						let targetTask = null;
						for (let t = 0; t < currentTasks.length; t++) {
							let taskDropZone = currentTasks[t];
							let targetRect = taskDropZone.getBoundingClientRect();
							if(self.rectanglesIntersect({
								top: event.detail.clientY,
								right: event.detail.clientX + 10,
								bottom: event.detail.clientY + 10,
								left: event.detail.clientX
							}, targetRect)) {
								targetTask = taskDropZone.dataset.source ? taskDropZone.dataset.source : -1;
							}
						}
						if (targetTask && targetTask !== -1 && self.vault.orgTier !== 'professional') {
							for (let e = 0; e < self.uploadFileQueue.length; e++) {
								self.uploadFileQueue[e].upload.taskId = targetTask;
							}
							console.log("Attach file to target task.");
						}


					} catch (error) {
						console.log(error);
					}
				} else {
					await self.receiveFilesFromInsideDrop(event);
				}
			} else {
				console.log("Invalid outside file drop event.");
			}
		},
		async receiveFilesFromInsideDrop(event) {
			return new Promise((resolve, reject) => {
				let self = this;
				let dragRect = event.detail.target.getBoundingClientRect();
				let currentFolders = document.querySelectorAll(".directory-item");
				let currentTasks = document.querySelectorAll(".task-drop-item");
				let targetFolder = null;
				let targetTask = null;

				for (let c = 0; c < currentFolders.length; c++) {
					let folder = currentFolders[c];
					let targetRect = folder.getBoundingClientRect();
					if(self.rectanglesIntersect({
						top: event.detail.clientY,
						right: event.detail.clientX + 10,
						bottom: event.detail.clientY + 10,
						left: event.detail.clientX
					}, targetRect)) {
						targetFolder = folder.dataset.source ? folder.dataset.source : -1;
						if (targetFolder !== -1) {
							let targetFolderItem = self.vaultFiles.find(tmp => tmp.id === targetFolder);
							console.log("Moving file to " + targetFolderItem.name);
						} else {
							console.log("Moving file to home directory.");
						}
					}
				}

				for (let t = 0; t < currentTasks.length; t++) {
					let taskDropZone = currentTasks[t];
					let targetRect = taskDropZone.getBoundingClientRect();
					if(self.rectanglesIntersect({
						top: event.detail.clientY,
						right: event.detail.clientX + 10,
						bottom: event.detail.clientY + 10,
						left: event.detail.clientX
					}, targetRect)) {
						targetTask = taskDropZone.dataset.source ? taskDropZone.dataset.source : -1;
					}
				}

				self.innerDragFiles = self.innerDragFiles.filter(tmpFile => tmpFile.extension !== 'fld');

				if (targetTask && targetTask !== -1 && self.vault.orgTier !== 'professional') {
					self.attachFileToTask(targetTask, self.innerDragFiles);
					console.log("Attach file to target task.");
				}

				if (targetFolder && self.userVaultPermissions && self.userVaultPermissions.rename_files) {
					console.log("Files from inner drop.");
					//console.log(`Drag ${self.innerDragFiles.join(',')} to ${targetFolder}`);

					self.moveSelectedFilesAndFolders(self.innerDragFiles, targetFolder);
				}

				//self.refreshFiles(true);
				resolve(true);
			});
		},
		attachFileToTask(taskId, files) {
			let self = this;
			let taskChanged = false;
			let task = self.vaultTasks.find(t => t.id === taskId);
			if (task) {
				for (let f = 0; f < files.length; f++) {
					let file = files[f];
					if (!task.attached_files || task.attached_files.length === 0) {
						task.attached_files = [];
					}
					if (task.attached_files && task.attached_files.indexOf(file.id) < 0) {
						task.attached_files.push(file.id);
						taskChanged = true;
					}
				}
				console.log(JSON.stringify(task));

				if (task.action_type === "File Request" && self.cognito && self.cognito.attributes["custom:mutableUserType"] === 'guest') {
					task.status = "Done";
				}
			}
			if (taskChanged) {
				self.editTask(task);
			}
		},
		rectanglesIntersect(r1, r2) {
			return !(r2.left > r1.right ||
				r2.right < r1.left ||
				r2.top > r1.bottom ||
				r2.bottom < r1.top);
		},
		async processFilesForUpload(files, directories, taskId) {
			return new Promise(async (resolve, reject) => {
				let self = this;
				//console.log("Want standard input.");
				let droppedItems = await this.processDroppedFiles({files, directories});
				console.log("Have " + droppedItems.length + " dropped items.");
				for (let di = 0; di < droppedItems.length; di++) {
					droppedItems[di] = self.mockFileSchemaForUploadQueue(droppedItems[di], self);

					if (taskId) {
						droppedItems[di].upload.taskId = taskId;
					}
					//console.log("Dropped item: " + di);
					//console.dir(droppedItems[di]);
					//1. Check for existing file being uploaded.
					let matchingUpload = self.uploadFileQueue.find(file => (file.parent_folder_file_id + "_" + file.name) === (droppedItems[di].parent_folder_file_id + "_" + droppedItems[di].name));
					//console.log("Dropped item ID: " + droppedItems[di].id);
					self.recentActivitySelected[droppedItems[di].id] = true;
					if (typeof matchingUpload === "undefined" || !matchingUpload) {
						let uploadFullPath = droppedItems[di].upload.directory + "__" + droppedItems[di].upload.filename;

						for (let x = 0; self.vaultFiles.length > x; x++) {
							if (uploadFullPath === ((self.vaultFiles[x].parent_folder_file_id ? self.vaultFiles[x].parent_folder_file_id : null) + "__" + self.vaultFiles[x].name)
								&& self.vaultFiles[x]._deleted !== 1) {
								self.vaultFiles[x].status = "uploading";
								break;
							}
						}

						self.uploadFileQueue.push(droppedItems[di]);
					}
				}
				self.queuePaused = false;

				resolve(true);
			});
		},
		mockFileSchemaForUploadQueue(droppedFile, self) {
			let currentTime = new Date();
			droppedFile.id = droppedFile.upload.uuid;
			droppedFile.parent_folder_file_id = droppedFile.upload.directory;
			droppedFile.vault_id = self.vault.id;
			droppedFile.org_id = self.organizationId;

			if (['iPad Simulator', 'iPhone Simulator', 'iPod Simulator',
				'iPad', 'iPhone', 'iPod'].includes(navigator.platform)) {
				let fileModified = new Date(droppedFile.body.lastModified);
				if (droppedFile.upload.filename.match(/\d{11}__.+(\.MOV$)/)) {
					droppedFile.upload.filename = "Video " + moment(fileModified).format("ddd, MMM Do YYYY, h:mm:ss a") + ".mov";
				} else if (droppedFile.upload.filename === "image.jpg" || droppedFile.upload.filename === "image.jpeg") {
					droppedFile.upload.filename = "Photo " + moment(fileModified).format("ddd, MMM Do YYYY, h:mm:ss a") + ".jpg";
				}
			}

			droppedFile.name = droppedFile.upload.filename;
			droppedFile.extension = droppedFile.upload.filename && droppedFile.upload.filename.indexOf('.') > -1 ? droppedFile.upload.filename.split('.').pop() : '';

			if (!droppedFile.meta) {
				droppedFile.meta = {};
			}
			if (droppedFile.body) {
				droppedFile.size = droppedFile.body.size;
			} else {
				droppedFile.size = droppedFile.meta && droppedFile.meta.size ? droppedFile.meta.size : droppedFile.body.fileSize;
			}

			//droppedFile.meta.size = droppedFile.size;

			droppedFile.created_date = currentTime.getTime();
			droppedFile.created_by = self.cognito.attributes.sub;
			droppedFile.created_by_name = self.cognito.attributes.name;
			droppedFile.modified_on = currentTime.getTime();
			droppedFile.modified_by = self.cognito.attributes.sub;
			droppedFile.modified_by_name = self.cognito.attributes.name;
			droppedFile.downloaded_by = [];
			droppedFile.downloaded_by_host = false;
			droppedFile.uploaded_by_host = self.cognito.attributes["custom:mutableUserType"] === 'admin' || self.cognito.attributes["custom:mutableUserType"] === 'member'
			droppedFile.comments =  [];
			droppedFile._version = 0;
			droppedFile._deleted = 0;
			droppedFile._lastChangedAt = currentTime.getTime();
			if (!droppedFile.fullPath) {
				droppedFile.fullPath = "";
			}
			return droppedFile;
		},
		abortFileUpload(file) {
			if (file && file.upload && file.upload.request) {
				try {
					if (file.status !== "done") {
						file.upload.request.abort();
						this.removeFileFromQueue(file.upload.uuid);
						this.notification('success', `Uploading File ${file.name} has been cancelled.`);
					} else {
						this.removeFileFromQueue(file.upload.uuid);
					}
				} catch (error) {
					this.error(`Unable to cancel file upload for ${file.name}.`);
				}
			} else if (file && file.upload) {
				this.removeFileFromQueue(file.upload.uuid);
				this.notification('success', `File ${file.name} has been removed from the upload queue.`);
			}
		},

		async getAllFileEntries(dataTransfer) {
			let dataTransferItemList = [];
			for (let i = 0; i < dataTransfer.files.length; i++) {
				dataTransferItemList.push({file: dataTransfer.files[i], item: dataTransfer.items[i], entity: dataTransfer.items[i].webkitGetAsEntry()});
			}
			return new Promise(async (resolve, reject) => {
				let self = this;
				let fileEntries = [];
				let dirEntries = [];
				// Use BFS to traverse entire directory/file structure
				let queue = [...dataTransferItemList];

				while (queue.length > 0) {
					let originalEntry = queue.shift();
					let entry = originalEntry;
					if (entry && entry.entity) {
						entry = entry.entity;
					}

					if (!entry) {
						console.error("No file entry found.");
					}

					let entryMetadata = await self.getFileMetadata(entry);
					let entryFileHandler = await self.getFileHandler(entry);

					if (entry.isFile) {
						fileEntries.push({fileHandler: entryFileHandler, fileMeta: entryMetadata, fileBody: originalEntry, fileWebKit: entry});
						//console.log(`${entry.name}, ${entry.fullPath}, isFile: ${entry.isFile}`);
					} else {
						dirEntries.push(entry);
						//console.log(`${entry.name}, ${entry.fullPath}, isDirectory: ${entry.isDirectory}`);
						queue.push(...await self.readAllDirectoryEntries(entry.createReader()));
					}
				}
				resolve({directories: dirEntries, files: fileEntries});
			});
		},
		async readAllDirectoryEntries(directoryReader) {
			let self = this;
			let entries = [];
			let readEntries = await self.readEntriesPromise(directoryReader);
			while (readEntries.length > 0) {
				entries.push(...readEntries);
				readEntries = await self.readEntriesPromise(directoryReader);
			}
			return entries;
		},
		async readEntriesPromise(directoryReader) {
			try {
				return await new Promise((resolve, reject) => {
					directoryReader.readEntries(resolve, reject);
				});
			} catch (err) {
				console.log(err);
			}
		},
		async createMissingFolders(directories, rootFolderId) {
			let self = this;
			return new Promise(async (resolve, reject) => {
				let missingFolderIds = [];
				for (let d = 0; d < directories.length; d++) {
					//console.log(`Check or create: ${directories[d].fullPath}`);
					let dirPaths = directories[d].fullPath.split('/');
					let lastParent = rootFolderId;
					for (let p = 0; p < dirPaths.length; p++) {
						//walk through each existing vault file folder.
						//console.log(`Does ${dirPaths[p]} exist?`);
						if (dirPaths[p]) {
							let matchingFolder = self.vaultFiles.find(file =>
								file.name.toLowerCase() === dirPaths[p].toLowerCase() &&
								file.extension.toLowerCase() === "fld" &&
								(
									(!file.parent_folder_file_id && !lastParent) ||
									file.parent_folder_file_id === lastParent)
							);
							if (matchingFolder) {
								lastParent = matchingFolder.id;
							} else {
								lastParent = await self.createNewFolder(dirPaths[p], lastParent);
								missingFolderIds.push(lastParent);
							}
						}
					}
				}
				resolve(missingFolderIds);
			});
		},
		async assignParentFolderIds(files, baseFolderId) {
			let self = this;

			return new Promise(async (resolve, reject) => {
				let updatedFiles = [];
				for (let f = 0; f < files.length; f++) {
					let fileEntry = files[f];
					//let file = fileEntry && fileEntry.fileBody ? fileEntry.fileBody : fileEntry.fileMeta;
					let filePath = "";
					if (fileEntry && fileEntry.fileWebKit && fileEntry.fileWebKit.fullPath) {
						filePath = fileEntry.fileWebKit.fullPath;
					}
					if (!filePath) {
						filePath = fileEntry.webkitRelativePath;
					}

					let paths = filePath.split('/').filter(seg => !!seg);


					let lastParentFolderId = baseFolderId ? baseFolderId : null;

					for (let p = 0; p < paths.length - 1; p++) {
						let tmpPath = paths[p];
						let matchedPath =
							self.vaultFiles.find(existingFile => existingFile.name.toLowerCase() === tmpPath.toLowerCase() && existingFile.extension === "fld" && ((!existingFile.parent_folder_file_id && !lastParentFolderId) || existingFile.parent_folder_file_id === lastParentFolderId));
						if (matchedPath) {
							lastParentFolderId = matchedPath.id;
						} else {
							reject("Unable to map path for file.");
						}
					}

					let fileBody = fileEntry.fileWebKit ? fileEntry.fileWebKit : fileEntry.fileBody;
					if (!fileBody) {
						fileBody = fileEntry;
					}
					updatedFiles.push({
						entry: fileEntry.fileHandler ? fileEntry.fileHandler : fileEntry,
						meta: fileEntry.fileMeta ? fileEntry.fileMeta : fileEntry,
						body: fileBody,
						status: 'queued',
						upload: {
							progress: 0,
							directory: lastParentFolderId,
							completedAt: null,
							filename: fileEntry.name ? fileEntry.name : fileEntry.fileHandler.name,
							uuid: self.uuid()
						}
					});
				}
				resolve(updatedFiles);
			});
		},
		async getFileHandler(entry) {
			return new Promise((resolve, reject) => {
				try {
					if (entry && typeof entry.file === "function") {
						entry.file(function (file) {
							resolve(file);
						});
					} else {
						resolve(entry);
					}
				} catch (error) {
					console.log("Unable to get file for entry.");
					reject(error);
				}
			});
		},
		async getFileMetadata(entry) {
			return new Promise((resolve, reject) => {
				try {
					if (entry && typeof entry.getMetadata === "function") {
						entry.getMetadata(function (metadata) {
							resolve(metadata);
						});
					} else {
						resolve({});
					}
				} catch (error) {
					console.log("Unable to get metadata for entry.");
					reject(error);
				}
			});
		},
		async processDroppedFiles(allEntries) {
			return new Promise(async (resolve, reject) => {
				let self = this;
				let rootFolderId = self.currentFolderFile ? self.currentFolderFile.id : null;

				//2. Check each directory, create directory if needed
				let missingFolderIds = await self.createMissingFolders(allEntries.directories, rootFolderId);
				//remove these from queue immediately

				console.log("Created missing folders: " + missingFolderIds.length);

				//3. Process meta data for each file
				//let filesWithMetaData = await self.gatherMetaDataForFiles(allEntries.files);


				//4. Map parent folder id to each file
				let fileEntries = await self.assignParentFolderIds(allEntries.files, rootFolderId);
				//console.log("Received " + fileEntries.length + " files from drop.");

				resolve(fileEntries);
			});
		},
		dragFile(event, isOver) {
			this.isDragging = isOver;
			//event.preventDefault();
		},
		async uploadFiles() {
			let self = this;
			if (self.uploadInProgress !== true && self.uploadFileQueue.length > 0) {
				self.uploadInProgress = true;
				
				// Only show file accumulator when there are actual files to process
				// and user hasn't recently closed it
				const filesToProcess = self.uploadFileQueue.filter(f => f.status !== "done" && f.status !== "error");
				if (filesToProcess.length > 0) {
					const uploadStartTimestamp = Date.now();
					const shouldShow = this.fileAccumulator.autoShow && 
						!this.fileAccumulator.isVisible &&
						(!this.fileAccumulator.lastClosedTimestamp || 
						 uploadStartTimestamp > this.fileAccumulator.lastClosedTimestamp);
					
					if (shouldShow) {
						this.showFileAccumulatorForUploads();
					}
				}
				
				let currentFileIndex = 0;
				let currentUploadFile = null;
				for (let f = 0; f < self.uploadFileQueue.length; f++) {
					if (self.uploadFileQueue[f].status !== "done" && self.uploadFileQueue[f].status !== "error") {
						currentUploadFile = self.uploadFileQueue[f];
						currentFileIndex = f;
						break;
					}
				}

				if (currentUploadFile) {
					//self.log("Send off the request for a new file.");
					//self.debug("Upload directly to s3, then when successful call fileuploaded");

					let currentPath = self.breadcrumbs.map(crumb => crumb.name).join('/');
					let targetPath = currentPath + "/" + (currentUploadFile.entry.fullPath ? currentUploadFile.entry.fullPath : "");
					targetPath = targetPath.replaceAll("//", "/");
					let folderObject = await self.getFolderIdForPath(targetPath);
					if (!currentUploadFile.parent_folder_file_id && folderObject.folderId) {
						currentUploadFile.parent_folder_file_id = folderObject.folderId;
					}

					//Get existing file name.

					//DONE: Collapse folders, find existing, and show updates on screen...
					//DONE: Folder itself should be the progress bar and remove upload queue...
					let uploadFullPath = currentUploadFile.upload.directory + "__" + currentUploadFile.upload.filename;
					let existingFileId = null;
					for (let x = 0; self.vaultFiles.length > x; x++) {
						if (uploadFullPath === ((self.vaultFiles[x].parent_folder_file_id ? self.vaultFiles[x].parent_folder_file_id : null) + "__" + self.vaultFiles[x].name)
							&& self.vaultFiles[x]._deleted !== 1) {
							existingFileId = self.vaultFiles[x].id;
						}
					}

					//console.log("Upload File Path: " + uploadFullPath);
					//console.log("Existing File ID: " + existingFileId);

					let existingVaultFile = this.vaultFiles.find(selectedFile => (existingFileId && selectedFile.id === existingFileId) || selectedFile.id === currentUploadFile.upload.uuid);
					if (existingVaultFile) {
						existingVaultFile.status = "uploading";
					}

					vaultService.uploadFile(
						self.$data.vault.id,
						self.$data.vault.org_id,
						currentUploadFile,
						currentFileIndex,
						self.$data.vaultToken.Credentials,
						existingFileId
					).then(response => {
						currentUploadFile.status = "done";
						currentUploadFile.upload.progress = 100;
						currentUploadFile.upload.completedAt = new Date();
						self.updateQueueWithFile(currentUploadFile, existingFileId);
						self.uploadInProgress = false;
						if (currentUploadFile.upload && currentUploadFile.upload.taskId) {
							self.attachFileToTask(currentUploadFile.upload.taskId, [response]);
						}
						//TODO This overwrite method could get bulky if there are a lot of files to sift through to find the duplicate
						if (!self.vaultFiles) {
							self.vaultFiles = [];
						}
						/*
						for(let x=0; self.vaultFiles.length > x;x++){
							if(response.name === self.vaultFiles[x].path && self.vaultFiles[x]._deleted !== 1){
								self.deleteFile(self.vaultFiles[x]);
							}
						}
						*/

						if (!existingFileId) {
							self.vaultFiles.push(response);
						} else {
							let fileThumbKey = self.getS3KeyForThumbnail(response, self.$data.vault);
							setTimeout(function() {
								EventBus.$emit("refreshlazy", {oldId: fileThumbKey, newId: fileThumbKey});
							}, 10000);
						}

						if (self.uploadFileQueue.length > 0) {
							setTimeout(self.uploadFiles, 300);
						}

						/*
						if (self.uploadFileQueue.length === 0) {
							self.refreshFiles(true);
						}*/
					}).catch(error => {
						console.log("ERROR: Unable to call uploadFile from the vault service: " + JSON.stringify(error));
						currentUploadFile.status = "error";
						self.updateQueueWithFile(currentUploadFile, existingFileId);
						self.uploadInProgress = false;
						self.notification('error', "Upload failed on file - " + currentUploadFile.upload.filename);
						setTimeout(self.uploadFiles, 300);
					});
				} else {
					self.uploadInProgress = false;
				}
			}
		},
		updateQueueWithFile(file, existingFileId) {
			//console.log(`Update file in queue ${file.upload.uuid} or ${existingFileId}`);
			if (existingFileId) {
				//let existingVaultFile = this.vaultFiles.find(selectedFile => (existingFileId && selectedFile.id === existingFileId) || selectedFile.id === file.upload.uuid);
				for (let sf = 0; sf < this.vaultFiles.length; sf++) {
					if ((existingFileId && this.vaultFiles[sf].id === existingFileId) || this.vaultFiles[sf].id === file.upload.uuid) {
						let currentTime = new Date();
						this.vaultFiles[sf]._lastChangedAt = currentTime.getTime();
						this.vaultFiles[sf].status = "done";
						
						// Add to file accumulator when upload completes
						this.addToFileAccumulator(this.vaultFiles[sf]);
					}
				}

				//file == existingQueueFile
				//console.log("Updated queue length: " + this.vaultFiles.length);
			} else {
				console.log("No update the file queue.");
			}
		},
		clearTasks() {
			let self = this;
			self.progress.clearTasksDialog = true;
			self.openPopup('clearTasksDialog');
			self.closePopup('editTask');
		},
		confirmClearTasks(event) {
			let self = this;
			console.log("Confirmed.");

			vaultService.mutation("deleteTask", {
				task_id: "66c6b8f7-f1b2-4d48-a29b-3b6837accbc5",
				vault_id: self.vault.id,
				org_id: self.vault.org_id,
				num_tasks_closed: 0,
				num_tasks_open: 0,
				earliest_open_task_date: ""
			}).then(response => {
				console.log(response);
				self.closePopup('clearTasksDialog');

				for (let i = 0; i < self.vaultTasks.length; i++) {
					self.vaultTasks[i]._deleted = 1;
				}

				self.progress.clearTasksDialog = false;
			}).catch(error => {
				console.log("Error: " + JSON.stringify(error));
				alert("Unable to remove all tasks, please try again.");
				self.closePopup('taskDeleteDialog');
				self.closePopup('editTask');
				self.clearNewTask();
				self.progress.taskDeleteDialog = false;
			});
		},
		openComposeNotificationTaskRemindersEditor() {
			this.newNotificationEmailMessage = this.defaultTaskNotificationEmailMessage + "";
			this.editedEmailMessage = this.renderedNotificationMessage;
			this.selectedNotificationEmails = [...this.uploadEmailAddresses];
			this.openPopup('composeNotification');
		},
		openComposeNotificationEditor() {
			this.newNotificationEmailMessage = this.defaultNotificationEmailMessage + "";
			this.editedEmailMessage = this.renderedNotificationMessage;
			this.selectedNotificationEmails = [...this.uploadEmailAddresses];
			this.openPopup('composeNotification');
		},
		openComposeFilesNotificationEditor() {
			this.newNotificationEmailMessage = "";
			this.editedEmailMessage = this.renderedNotificationMessage;
			this.selectedNotificationEmails = [...this.uploadEmailAddresses];
			this.openPopup('composeNotification');
		},
		testPopupMethod(data) {
			return new Promise((resolve, reject) => {
				alert("Test: " + JSON.stringify(data));
				resolve();
			});
		},
		selectNoRecentFiles() {
			let self = this;
			for (let i = 0; i < self.vaultFiles.length; i++) {
				let file = self.vaultFiles[i];
				//console.log("Key: " + key);
				self.$set(self.recentActivitySelected, file.id, false);
			}
			//console.log("Unselect unread files: " + JSON.stringify(self.recentActivitySelected));
		},
		selectUnreadFiles() {
			let self = this;

			for (let i = 0; i < self.vaultFiles.length; i++) {
				let file = self.vaultFiles[i];
				if ((typeof file.uploaded_by_host !== 'undefined'
						|| typeof file.downloaded_by_host !== 'undefined')
					&& self.fileWasNotDownloaded(file)) {
					self.$set(self.recentActivitySelected, file.id, true);
				} else {
					self.$set(self.recentActivitySelected, file.id, false);
				}
			}
			//console.log("Select unread files: " + JSON.stringify(this.recentActivitySelected));
		},
		addComment(task) {
			let currentTime = new Date();
			task.comments.push({
				id: this.uuid(),
				comment: this.newComment,
				created_date: currentTime.getTime(),
				created_by: this.cognito.attributes.sub,
				user_name: this.cognito.attributes.name,
				_version: 0,
				_deleted: 0,
				_lastChangedAt: currentTime.getTime()
			});
			this.newComment = "";
		},
		permissionSummary(member) {
			let permissions = "None";
			let permissionsList = [];
			if (member) {
				if (member.view_files) {
					permissionsList.push("Download");
				}
				if (member.upload_files) {
					permissionsList.push("Upload");
				}
				if (member.rename_files) {
					permissionsList.push("Move, Rename");
				}
				if (member.delete_files) {
					permissionsList.push("Delete");
				}
			}
			if (permissionsList.length > 0) {
				permissions = permissionsList.join(", ");
			}
			return permissions;
		},
		sendNotificationEmail(email) {
			return new Promise((resolve, reject) => {
				let now = new Date();
				if (!this.selectedNotificationEmails || this.selectedNotificationEmails.length === 0) {
					this.notification("error", "Please select at least one portal guest to send the email.");
					reject("Please select at least one portal guest to send the email.");
				} else {
					let toEmails = "admin";
					if (this.cognito.attributes["custom:mutableUserType"] !== "guest" && this.cognito.attributes["custom:mutableOrgId"] === this.vault.org_id) {
						toEmails = this.selectedNotificationEmails.map(notEm => {return notEm.email}).join(",");
					}

					vaultService.mutation("newAuditNotificationAction", {
						action: "custom_upload",
						vault_id: this.vault.id,
						org_id: this.vault.org_id ? this.vault.org_id : '',
						description: this.editedEmailMessage,
						filename: toEmails,
						action_date: now.getTime().toString()
					}).then(result => {
						this.notification("success", "File activity notification email send successfully.");
						resolve();
					}).catch(error => {
						this.notification("error", "Unable to send file activity notification email, please try again.");
						console.log(error);
						reject("Unable to send file activity notification email, please try again.");
					});
				}
			});
		},
		saveTask(task) {
			return new Promise(async (resolve, reject) => {
				let self = this;
				self.progress.createTask = true;
				if (!task || !task.title) {
					self.notification('error', "Please complete the required fields before saving this task.");
				} else {
					if (task && !task.id) {
						if (task.multiCreate === true) {
							let taskTitles = task.title.split("\n");
							for (let i = 0; i < taskTitles.length; i++) {
								let tmpTask = JSON.parse(JSON.stringify(task));
								tmpTask.title = taskTitles[i];
								await self.createTask(tmpTask);
							}
						} else {
							await self.createTask(task);
						}
					} else {
						self.editTask(task);
					}
				}
				self.progress.createTask = false;
				resolve(); //TODO: Make promises and await create and edit methods
			});
		},
		setTodayTaskCalendar() {
			this.taskCalendarFocus = '';
			//this.notification('success', "Test Message");
		},
		getTasksForCalendar(event) {
			let self = this;
			const taskDueDates = []

			if (self.vaultTasks) {
				for (let i = 0; i < self.vaultTasks.length; i++) {
					let tmpTask = self.vaultTasks[i];
					if (tmpTask.due_date) {
						let min = new Date(`${tmpTask.due_date}T01:00:00`).getTime();
						let max = new Date(`${tmpTask.due_date}T22:59:59`).getTime();

						taskDueDates.push({
							name: tmpTask.title,
							'start': min,
							'end': max,
							status: tmpTask.status,
							color: this.colors[this.rnd(0, this.colors.length - 1)],
							timed: false,
							task_id: tmpTask.id
						});
					}
				}

				self.taskDueDates = taskDueDates;
			}
		},
		dueDateCheck(task){
			if(task && task.status !== "Done"){
				let today = moment(new Date());
				return today.isBefore(task.due_date);
			}else{
				return true;
			}

		},
		editTaskFromCalendar(event) {
			if (event && event.nativeEvent) {
				event.nativeEvent.stopPropagation();
			}

			let task = this.vaultTasks.find(tmpTask => tmpTask.id === event.eventParsed.input.task_id);
			this.openEditTask(task);
		},
		getTaskColor (event) {
			return 'green';
		},
		rnd (a, b) {
			return Math.floor((b - a + 1) * Math.random()) + a
		},
		deleteTask(task) {
			let self = this;
			console.log(JSON.stringify(task));
			self.progress.taskDeleteDialog = true;

			let numClosed = self.numberOfDoneTasks - (task.status !== "Done" ? 0 : 1);
			let numOpen = self.numberOfOpenTasks - (task.status !== "Done" ? 1 : 0);
			let earliestDate = self.earliestTaskDate;
			vaultService.mutation("deleteTask", {
				task_id: task.id,
				vault_id: self.vault.id,
				org_id: self.vault.org_id,
				num_tasks_closed: numClosed,
				num_tasks_open: numOpen,
				earliest_open_task_date: earliestDate
			}).then(response => {
				console.log(response);
				self.closePopup('taskDeleteDialog');
				self.closePopup('editTask');

				for (let i = 0; i < self.vaultTasks.length; i++) {
					if (self.vaultTasks[i].id === task.id) {
						self.vaultTasks[i]._deleted = 1;
						self.vaultTasks.splice(i, 1);
						break;
					}
				}
				self.clearNewTask();
				self.progress.taskDeleteDialog = false;
			}).catch(error => {
				console.log("Error: " + JSON.stringify(error));
				self.closePopup('taskDeleteDialog');
				self.closePopup('editTask');
				self.clearNewTask();
				self.progress.taskDeleteDialog = false;
			});
		},
		openEditTask(task) {
			task.due_date_formatted = task.due_date ? this.formatDate(task.due_date) : '';
			if(this.cognito.attributes['custom:mutableUserType'] === "guest"){
				this.openPopup('editTask_guest', task);
			}else{
				this.openPopup('editTask', task);
			}
		},
		clearNewTask(date) {
			//this.$refs.newTaskForm.resetValidation();
			this.newTask = {
				title: "",
				action_type: "General",
				description: "",
				due_date: date ? (new Date(date)).toISOString().split('T')[0] : null,
				due_date_formatted: date ? this.formatDate(date) : "",
				status: "Open",
				_deleted: 0
			};
		},
		updateFileToTask(task, refs) {
			this.lastTaskIdFromUpload = task.id;
			if (refs) {
				refs.file.click();
			}
		},
		openCreateNewTaskPopup(event) {
			if (this.cognito.attributes['custom:mutableUserType'] !== 'guest') {
				this.clearNewTask(event ? event.date : undefined);
				this.openPopup('createTask', this.newTask)
			}
		},
		createTask(task) {
			return new Promise((resolve, reject) => {
				let self = this;
				self.progress.createTask = true;

				if (!task) {
					task = self.newTask;
				}

				task.id = self.uuid();

				let numClosed = self.numberOfDoneTasks + (task.status !== "Done" ? 0 : 1);
				let numOpen = self.numberOfOpenTasks + (task.status !== "Done" ? 1 : 0);
				let earliestDate = self.earliestTaskDate;

				vaultService.mutation("addTask", {
					vault_id: self.vault.id,
					org_id: self.vault.org_id,
					attached_files: task.attached_files ? task.attached_files : [],
					action_type: task.action_type ? task.action_type : "",
					title: task.title ? task.title : "",
					description: task.description ? task.description : "",
					status: task.status,
					clientResponse: "",
					send_reminder: task.send_reminder ? task.send_reminder : false,
					due_date: task.due_date ? task.due_date : "",
					assigned_guest_ids: task.assigned_guest_ids ? task.assigned_guest_ids : [],
					assigned_guest_names: task.assigned_guest_names ? task.assigned_guest_names : [],
					assigned_member_ids: task.assigned_member_ids ? task.assigned_member_ids : [],
					assigned_member_names: task.assigned_member_names ? task.assigned_member_names : [],
					num_tasks_closed: numClosed,
					num_tasks_open: numOpen,
					earliest_open_task_date: earliestDate
				}).then(response => {
					task.id = response;
					self.closePopup('createTask');
					self.clearNewTask();
					self.progress.createTask = false;
				self.vaultTasks.push(task);

				if (self.numberOfOpenTasks > 0 && self.vault && self.vault.orgTier && (self.vault.orgTier === 'enterprise' || self.vault.orgTier === 'large firm')) {
					self.viewMode = 1;
				} else {
					self.viewMode = 0;
				}
					self.getTasksForCalendar();
					resolve(task);
				}).catch(error => {
					console.log("Error: " + JSON.stringify(error));
					self.closePopup('createTask');
					self.clearNewTask();
					self.progress.createTask = false;
					reject("Error creating task.");
				});
			});
		},
		editTask(task) {
			console.dir(task);

			let self = this;
			self.progress.createTask = true;
			let now = new Date();

			let numClosed = self.numberOfDoneTasks;
			let numOpen = self.numberOfOpenTasks;
			let earliest = self.earliestTaskDate;

			if (typeof task.send_reminder === 'undefined' || task.send_reminder === null) {
				task.send_reminder = false;
			}

			vaultService.mutation("updateTask",
				{
					...task,
					num_tasks_closed: numClosed,
					num_tasks_open: numOpen,
					earliest_open_task_date: earliest
				}
			).then(response => {
				console.log(response);
				self.closePopup('editTask');
				self.clearNewTask();
				self.progress.createTask = false;
			}).catch(error => {
				console.log("Error: " + JSON.stringify(error));
				self.closePopup('editTask');
				self.clearNewTask();
				self.progress.createTask = false;
			});
			if(task.status === 'Done'){
				vaultService.mutation("newAuditNotificationAction", {
					action: "Task Complete",
					vault_id: self.vault.id,
					org_id: self.vault.org_id,
					filename: task.title,
					description: "Task Complete",
					action_date: now.getTime().toString()
				}).then(response => {
					console.log("Task Complete Notification Trigger.");
				});
			}
		},
		taskBlob(task){
			let taskHeader = "Task Title:";
			switch(task.action_type) {
				case 'Question?':
					taskHeader = 'Answer the following:';
					break;
				case 'File Request':
					taskHeader = 'Upload this File:';
					break;
				case 'Sign Document':
					taskHeader = 'Sign this File:';
					break;
				case 'Fill Form':
					taskHeader = 'Fill out this form:';
					break;
				case 'General':
					taskHeader = 'Task To Do:';
					break;
			}
			return taskHeader;
		},
		taskTitleFieldName(task) {
			let taskHeader = "Enter Task Title or Request";
			switch(task.action_type) {
				case 'Question?':
					taskHeader = 'Enter Question you want Answered';
					break;
				case 'File Request':
					taskHeader = 'Description of File you want Uploaded';
					break;
				case 'Sign Document':
					taskHeader = 'Description of the PDF you want Signed';
					break;
				case 'Fill Form':
					taskHeader = 'Description of the PDF you want Completed.';
					break;
				case 'General':
					taskHeader = 'Enter Task Title or Request';
					break;
			}
			return taskHeader;
		},
		selectActivityForDate(dateId) {
			console.log(JSON.stringify(this.recentActivitySelected));
			for (let ra = 0; ra < this.allFilesGroupedByDate.length; ra++) {
				let groupedFiles = this.allFilesGroupedByDate[ra];
				//console.log(JSON.stringify(this.allFilesGroupedByDate));
				if (dateId === groupedFiles.fieldId) {
					for (let fa = 0; fa < groupedFiles.files.length; fa++) {
						let selectFile = groupedFiles.files[fa];
						this.recentActivitySelected[selectFile.id] = true;
					}
				}
			}
		},
		getLatestDate(file) {
			let tmpDate = file._lastChangedAt;
			if (file.modified_on) {
				tmpDate = file.modified_on;
			} else if (file.created_date) {
				tmpDate = file.created_date;
			}
			return tmpDate;
		},
		userNameFromFile(file) {
			let info = this.userInfoFromFile(file);
			return info.displayName;
		},
		modifiedDateFromFile(file) {
			let info = this.userInfoFromFile(file);
			return info.modifiedDate;
		},
		userInfoFromFile(file) {
			//1. look for modified_by/on fields
			//2. look for created field
			//2a. get name from file info
			//2b. get name from members if org
			//2c. get name from vault permissions
			//3. if nothing assume uploaded by host

			let userId = file ? file.created_by : -1;
			let userName = "Uploaded by Host";
			let userEmail = null;
			let modifiedDate = file.created_date;
			let displayName = userName;

			if (!userId) {
				userId = -1;
			}

			if (file && file.modified_by) {
				userId = file.modified_by;
				userName = file.modified_by_name;
				userEmail = file.modified_by_email;
				modifiedDate = file.modified_on;
				if (userEmail && this.userTypeVisibility) {
					displayName = userName + " (" + userEmail + ")";
				} else {
					displayName = userName;
				}

			} else {
				if (!modifiedDate) {
					modifiedDate = file._lastChangedAt;
				}

				//find name

				let permissions = this.vault && this.vault.permissions ? this.vault.permissions : [];
				let permission = permissions.find(perm => perm.user_id === userId);
				if (permission && permission.user_name) {
					userName = permission.user_name;
					if (permission.user_email && this.userTypeVisibility) {
						displayName = permission.user_name + " (" + permission.user_email + ")";
					} else {
						displayName = permission.user_name;
					}
					displayName = permission.user_name + " (" + permission.user_email + ")";
				} else if (this.organization && this.organization.permissions) {
					let orgPermissions = this.organization.permissions ? this.organization.permissions : [];
					let orgPermission = orgPermissions.find(perm => perm.user_id === userId);
					if (orgPermission && orgPermission.user_name) {
						userName = orgPermission.user_name;
						if (orgPermission.user_email && this.userTypeVisibility) {
							displayName = orgPermission.user_name + " (" + orgPermission.user_email + ")";
						} else {
							displayName = orgPermission.user_name;
						}
					}
				}
			}

			return {
				displayName,
				userName,
				userEmail,
				userId,
				modifiedDate
			};
		},
		tasksFullTableSort(a, b) {
			//Sort date oldest first but an older date should be above a blank value
			if (!a && b) {
				return 1;
			} else if (a && !b) {
				return -1;
			} else if (!a && !b) {
				return 0;
			} else {
				return new Date(a) - new Date(b);
			}
		},
		customSort(items, index, isDesc) {
			//console.log("Sort by " + index);
			items.sort((a, b) => {
				if (index === '_lastChangedAt') {
					if (!isDesc[0]) {
						return new Date(b[index]) - new Date(a[index]);
					} else {
						return new Date(a[index]) - new Date(b[index]);
					}
				}
				else {
					if(typeof a[index] !== 'undefined'){
						if ((a.extension === "fld" || b.extension === "fld") && a.extension !== b.extension) {
							return a.extension === "fld" ? -1 : 1;
						} else if (!isDesc[0]) {
							return a[index].toLowerCase().localeCompare(b[index].toLowerCase());
						}
						else {
							return b[index].toLowerCase().localeCompare(a[index].toLowerCase());
						}
					}
				}
			});
			return items;
		},
		parentPdfSave(){
			this.loadingSave = !this.loadingSave;
			this.$refs["web-viewer"].savePdf();
		},
		pdfMessageReceived(xfdf, file, pdfSigned) {

			//TODO send the array buffer from export up to here to send to S3
			let self = this;
			self.pdfViewerFormDirty = false;
			self.loadingSave = false;
			console.log("PDF Saved..");
			let now = new Date();

			//Audit Notification
			vaultService.mutation("newAuditNotificationAction", {
				action: pdfSigned ? "PDF Signed" : "PDF Form Filled",
				vault_id: self.vault.id,
				org_id: self.vault.org_id,
				file_id: file.id,
				filename: file.name,
				description: pdfSigned ? "Signed PDF Form" : "Saved PDF Form.",
				action_date: now.getTime().toString()
			}).then(notificationEmails => {
				self.setFileDownloadedBy(file);
				if (notificationEmails !== self.vault.id) {
					if (notificationEmails.indexOf("|time_suppressed") > -1) {
						//self.notification("info", "Notification email has been suppressed due to a prior notification being send to portal members within the last 30 minutes.", true);
					} else {
						self.notification("success", "PDF Save Notification emailed to " + notificationEmails);
					}
				}
				file._lastChangedAt = now.getTime();
			});

			//check for related task
			let tasksOpenWithThisFile =
				self.vaultTasks.filter(t =>
					t.attached_files &&
					t.attached_files.indexOf(file.id) > -1 &&
					t.status !== 'Done' &&
					(t.action_type === 'Fill Form' || t.action_type === 'Sign Document'));
			console.log(tasksOpenWithThisFile.length + " tasks open related to this file.");
			if (tasksOpenWithThisFile.length > 0) {
				if (confirm("There is an associated task open named: " + tasksOpenWithThisFile[0].title + ", would you like to mark this as complete?") === true) {
					for (let t = 0; t < tasksOpenWithThisFile.length; t++) {
						tasksOpenWithThisFile[t].status = "Done";
						self.editTask(tasksOpenWithThisFile[t]);
					}
				}
			}
		},
		updatePdfDirtyFlag(flagState) {
			this.pdfViewerFormDirty = flagState;
		},
		fileStatusIcon(status) {
			switch(status) {
				case "complete": return 'fas fa-check-circle';
				case "uploading": return 'fas fa-sync-alt';
				default: return 'fas fa-times-circle';
			}
		},
		fileFromFullPath(fullPath) {
			return fullPath.replace(/^.*[\\\/]/, '');
		},
		dirFromFullPath(fullPath) {
			return fullPath.replace(/(.*?)[^/]*\..*$/,'$1');
		},
		humanFileSize(bytes, si=false, dp=1) {
			const thresh = si ? 1000 : 1024;

			if (Math.abs(bytes) < thresh) {
				return bytes + ' B';
			}

			const units = si
				? ['kB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB']
				: ['KiB', 'MiB', 'GiB', 'TiB', 'PiB', 'EiB', 'ZiB', 'YiB'];
			let u = -1;
			const r = 10**dp;

			do {
				bytes /= thresh;
				++u;
			} while (Math.round(Math.abs(bytes) * r) / r >= thresh && u < units.length - 1);


			return bytes.toFixed(dp) + ' ' + units[u];
		},
		uuid() {
			return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
				var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
				return v.toString(16);
			});
		},
		removeUrlExtension(name) {
			return name && name.indexOf(".url") > -1 ? name.replace(".url", "") : name;
		},
		acceptTerms() {
			let self = this;
			self.termsDialog = false
			vaultService.mutation("setVaultAsTermsAccepted", {'vault_id': self.vault.id, 'remove_vault': false}).then(response => {
				//console.log("Returned from set vault terms as accepted. " + response);
				//audit action
				let now = new Date();
				vaultService.mutation("newAuditNotificationAction", {
					action: "Portal Terms Accepted",
					vault_id: self.vault.id,
					org_id: this.organization && this.organization.id ? this.organization.id : this.organizationId,
					description: `Guest ${self.user.displayName} (${self.user.email}) accepted the following terms and conditions for portal ${self.vault.name}: ${self.termsAndConditions}`,
					action_date: now.getTime().toString()
				});

				vaultService.query("getUserById", undefined, "user", {vuexCache: false}).then(() => {});
			}).catch(err => {
				console.dir(err);
				self.notification('error', "Unable to set vault terms as accepted.");
			});
		},
		navigateFilePreview(offset) {
			let self = this;

			let changeFile = function() {
				self.loadingSave = false;
				let nextIndex = self.selectedFileToPreviewIndex;
				if (self.filteredFilesOnlyOnSearchAndDelete.length > 0) {
					nextIndex = self.selectedFileToPreviewIndex + offset;
					if (nextIndex < 0) {
						nextIndex = 0;
					} else if (nextIndex >= self.filteredFilesOnlyOnSearchAndDelete.length) {
						nextIndex = self.filteredFilesOnlyOnSearchAndDelete.length - 1;
					}
					if (nextIndex !== self.selectedFileToPreviewIndex) {
						self.selectFileToPreview(self.filteredFilesOnlyOnSearchAndDelete[nextIndex], self.vault);
					}
				}
			}

			if (self.pdfViewerFormDirty) {
				if (confirm("Warning, this PDF has unsaved changes! Do you still wish to leave the page?") === true) {
					self.pdfViewerFormDirty = false;
					changeFile();
				}
			} else {
				changeFile();
			}
		},
		markSelectedAsRead(overrideSelectedFilesWithRecentSelected) {
			let fileIds = [];
			let self = this;
			if (self.recentActivitySelected && overrideSelectedFilesWithRecentSelected) {
				for (let x in self.recentActivitySelected) {
					if (self.recentActivitySelected[x] === true) {
						let tmpFile = self.vaultFiles.find(file => file.id === x);
						if (tmpFile) {
							self.setFileDownloadedBy(tmpFile, true);
							fileIds.push(tmpFile.id);
						}
					}
				}
			} else {
				for (let i = 0; i < self.selectedFiles.length; i++) {
					self.setFileDownloadedBy(self.selectedFiles[i], true);
					if (self.selectedFiles[i].id) {
						fileIds.push(self.selectedFiles[i].id);
					}
				}
			}

			vaultService.mutation("markFilesAsRead", {fileIds, "org_id": self.vault.org_id, "vault_id": self.vault.id}).then(() => {
				console.log("Files marked as read.");
			});
		},
		fileWasNotDownloaded(file) {
			return !this.fileWasDownloaded(file);
		},
		fileWasDownloaded(file) {
			let wasDownloaded = false;
			//0. if not folder
			if (file.extension === "fld") {
				wasDownloaded = true;
			} else if (this.cognito && (this.cognito.attributes["custom:mutableUserType"] === "admin" || this.cognito.attributes["custom:mutableUserType"] === "member") &&
				(!!file.downloaded_by_host || !!file.uploaded_by_host)) {
				//1. else if (admin or member) && downloaded_by_host
				wasDownloaded = true;
			} else if (this.cognito) {
				//2. else if (guest) && myId in [downloaded_by]
				wasDownloaded = file.downloaded_by ? file.downloaded_by.indexOf(this.cognito.attributes.sub) > -1 : false;
				if (!wasDownloaded && file.created_by === this.cognito.attributes.sub) {
					wasDownloaded = true;
				}
			}

			return wasDownloaded;
		},
		selectFileToPreview(file, vault) {
			let self = this;
			self.selectedFileUrlTarget = null;

			if (typeof file === 'string') {
				file = self.vaultFiles.find(f => f.id === file);
			}

			if (file.upload && (file.upload.progress >= 0 && file.upload.progress < 100)) {
				console.log("Skipping file open during upload.");
			} else {
				let now = new Date();
				self.selectedFileToPreview = file;
				self.filePreviewImage = null;
				self.selectedFileToPreviewIndex = self.filteredFilesOnlyOnSearchAndDelete.indexOf(file);
				self.selectedPreviewFileUrlXfdf = null;
				if (file.extension.toLowerCase() === "fld") {
					self.downloadFile(file, vault);
				} else {
					vaultService.getSignedFileUrl(file, vault, true).then(fileUrl => {
						self.tab = 0;
						self.selectedPreviewFileText = "";
						self.selectedPreviewFileUrl = fileUrl;
						switch (file.extension.toLowerCase()) {
							case "fld":
								self.downloadFile(file, vault); break;
							case "apng":
							case "gif":
							case "jpg":
							case "jpeg":
							case "jfif":
							case "pjpeg":
							case "pjp":
							case "png":
							case "webp":
							case "bmp":
							case "ico":
							case "cur":
							case "tif":
							case "tiff":
								self.previewToolMode = "image";
								self.filePreviewMode = true;
								self.filePreviewImage = fileUrl;

								//self.$viewerApi({ images: [fileUrl], })

								//self.imagePreviewContainer.load(fileUrl);
								break;
							case "xlsx":
								self.previewToolMode = "xlsx";
								self.filePreviewMode = true;
								break;
							case "xls":
								self.previewToolMode = "xlsx";
								self.filePreviewMode = true;
								break;
							case "docx":
								self.previewToolMode = "docx";
								self.filePreviewMode = true;
								break;
							case "doc":
								self.previewToolMode = "docx";
								self.filePreviewMode = true;
								break;
							case "pptx":
								self.previewToolMode = "pptx";
								self.filePreviewMode = true;
								break;
							case "ppt":
								self.previewToolMode = "pptx";
								self.filePreviewMode = true;
								break;
							case "pdf":
								self.previewToolMode = "pdf";
								self.selectedPreviewFileUrlXfdf = null;
                                self.filePreviewMode = true;

								break;
							case "mp3":
							case "aif":
							case "wav":
								self.previewToolMode = "audio";
								self.filePreviewMode = true;
								break;
							case "m4v":
							case "avi":
							case "mp4":
								self.videoPlayerOptions.sources = [{
									type: "video/mp4",
									src: fileUrl
								}];
								self.previewToolMode = "video";
								self.filePreviewMode = true;
								//self.resizePreview();
								break;
							case "url":
								self.previewToolMode = "bookmark";
								self.filePreviewMode = true;
								self.downloadFile(file, vault, true, true);
								break;
							case "txt":
								self.previewToolMode = "text";
								vaultService.downloadFile(vault, file, this.$data.vaultToken.Credentials, true).then(data => {
									console.log("Loaded saved text data.");
									self.selectedPreviewFileText = data.Body;
									self.filePreviewMode = true;
								}).catch(error => {
									console.log("No xfdf data found for PDF. " + JSON.stringify(error));
									self.filePreviewMode = true;
								});
								break;
							default:
								self.previewToolMode = "notavailable";
								self.filePreviewMode = true;
								//this.downloadFile(file, vault);
								break;
						}

						vaultService.mutation("newAuditNotificationAction", {
							action: "Download",
							vault_id: vault.id,
							org_id: vault.org_id,
							file_id: file.id,
							filename: file.name,
							description: "Portal File Preview.",
							action_date: now.getTime().toString()
						}).then(notificationEmails => {
							self.setFileDownloadedBy(file);
							if (notificationEmails !== vault.id) {
								if (notificationEmails.indexOf("|time_suppressed") > -1) {
									//self.notification("info", "Notification email has been suppressed due to a prior notification being send to portal members within the last 30 minutes.", true);
								} else {
									self.notification("success", "Download Notification emailed to " + notificationEmails);
								}
							}
						});
					});
				}

			}
		},
		setFileDownloadedBy(file, onlyUpdateDownloadedBy) {
			if (this.cognito.attributes["custom:mutableUserType"] === "admin" || this.cognito.attributes["custom:mutableUserType"] === "member") {
				if (onlyUpdateDownloadedBy !== true) {
					file.downloaded_by_host = true;
				}
			}
			let downloadedArray = file.downloaded_by ? file.downloaded_by : [];
			if (downloadedArray.indexOf(this.cognito.attributes.sub) === -1) {
				downloadedArray.push(this.cognito.attributes.sub);
			}
		},
		resizePreview() {
			if (this.$refs.filePreviewRow.clientWidth > 0) {
				//this.videoPlayerOptions.width = this.$refs.filePreviewRow.clientWidth - 20;
			} else {
				//this.videoPlayerOptions.width = this.$refs.topVaultBar.clientWidth - 20;
			}
		},
		closeFilePreview() {
			if (this.pdfViewerFormDirty) {
				if (confirm("Warning, this PDF has unsaved changes! Do you still wish to leave the page?") === true) {
					this.filePreviewMode = false;
					this.selectedPreviewFileUrl = null;
					this.pdfViewerFormDirty = false;
				}
			} else {
				this.filePreviewMode = false;
				this.selectedPreviewFileUrl = null;
			}
		},
		saveExternalEmail() {
			let self = this;
			vaultService.mutation("saveVaultExternalEmail", {vault_id: this.vault.id, org_id: this.vault.org_id, email: this.vault.external_email}).then(response => {
				self.notification('success', "Vault external email saved.");
			}).catch(error => {
				self.notification('error', "Unable to save external email address. Please try again.");
				//console.log(JSON.stringify(error));
			});
		},
		openMoveSelectedFilesAndFolders(copyMode) {
			if (this.selectedFiles && this.selectedFiles.length > 0) {
				this.copyFileMode = !!copyMode;
				this.openPopup('selectFolder');
			} else {
				alert("Please select files to move or copy.");
			}
		},
		moveSelectedFilesAndFolders(filesToMove, targetFolderId) {
			let self = this;
			if (typeof filesToMove === 'undefined') {
				filesToMove = self.selectedFiles;
			}
			if (typeof targetFolderId === 'undefined') {
				targetFolderId = self.selectedTreeFolder && self.selectedTreeFolder.length > 0 ? self.selectedTreeFolder[0] : null;
			}

			self.popupError('selectFolder', null);

			if (!targetFolderId) {
				self.popupError('selectFolder', "Please select a destination folder.");
			} else {
				if ((self.currentFolderFile && self.currentFolderFile.id === targetFolderId)
					|| (!self.currentFolderFile && targetFolderId === -1)) {
					self.popupError('selectFolder', "The current folder is selected as the target folder.");
				} else {
					//if all filesToMove must have currentFolder as parent_folder_file_id..
					let allSelectedHaveSameParentFolderFileId = true;
					let allSelectedAreCurrentFolderId = true;
					let lastParentFolderId = -1;
					let selectedFileIds = [];
					let filesWillBeOverwritten = [];
					let letMoveProceed = true;
					let overwrittenFileIds = [];

					for (let i = 0; i < filesToMove.length; i++) {
						let foundConflictFile = self.vaultFiles.find(checkFile =>
							checkFile.parent_folder_file_id === targetFolderId
							&& checkFile._deleted !== 1
							&& checkFile.name === filesToMove[i].name);
						if (foundConflictFile) {
							filesWillBeOverwritten.push(filesToMove[i].name);
							letMoveProceed = false;
						}

						if (lastParentFolderId === -1) {
							lastParentFolderId = filesToMove[i].parent_folder_file_id;
						} else if (lastParentFolderId !== filesToMove[i].parent_folder_file_id) {
							allSelectedHaveSameParentFolderFileId = false;
						}
						if ((self.currentFolderFile && self.currentFolderFile.id !== filesToMove[i].parent_folder_file_id) ||
							(self.currentFolderFile !== filesToMove[i].parent_folder_file_id)) {
							allSelectedAreCurrentFolderId = false;
						}
						selectedFileIds.push(filesToMove[i].id);
						overwrittenFileIds.push(foundConflictFile ? foundConflictFile.id : null);
					}

					if (filesWillBeOverwritten.length > 0
						&& confirm('Are you sure you want to overwrite the following files: ' + filesWillBeOverwritten.join(", ") + '?')) {
						letMoveProceed = true;
					}

					//all selectedFiles, update parent_folder_file_id to be new folder.
					if (!allSelectedHaveSameParentFolderFileId) {
						self.popupError('selectFolder', "All selected files must be in the same folder.");
					} else if (!letMoveProceed) {
						self.modals.moveFile = false;
						self.progress.moveFile = false;
						self.popupError('selectFolder', "Request to move files has been canceled.");
					} else {
						//Send to lambda, selectedFileIds[ID] and targetFolderId[ID] as the target. -1 => null

						vaultService.mutation("moveFile", {
							"file_id": selectedFileIds,
							"overwrite_id": overwrittenFileIds,
							"org_id": self.$data.vault.org_id,
							"vault_id": self.$data.vault.id,
							"destination": targetFolderId !== -1 ? targetFolderId : undefined,
							"copy": self.copyFileMode
						}).then(response => {
							//TODO: Fix thumbnail on copied file.
							filesToMove = [];
							self.refreshFiles(true);
							self.modals.moveFile = false;
							self.progress.moveFile = false;
							self.notification('success', "File(s) moved Successfully!");

							self.selectedTreeFolder = [];
							self.closePopup('selectFolder');

							Promise.all(filesToMove.map(fileInfo => {
								vaultService.mutation("newAuditNotificationAction", {
									action: copyMode === true ? "Copy" : "Move",
									vault_id: self.$data.vault.id,
									org_id: self.$data.vault.org_id,
									file_id: fileInfo.id,
									filename: fileInfo.name,
									action_date: now.getTime().toString()
								});
							}));
						}).catch(error => {
							self.modals.moveFile = false;
							self.progress.moveFile = false;
							vaultService._error(error);
							self.notification('error', "Unable to move file, please contact the portal administrator for permission.");
							self.popupError('selectFolder', "Unable to move file, please contact the portal administrator for assistance. " + error);
						});
					}

				}
			}
		},
		showVersionHistory(file) {
			let self = this;

			vaultService.downloadFileVersions(this.vault, file, this.$data.vaultToken.Credentials);

			self.openPopup('versionHistory');
		},
		momentDate(timestamp, dateOnly) {
			if (typeof timestamp === 'string' && timestamp.indexOf('-') > -1) {
				return moment(timestamp).format(dateOnly ? "M/D/YYYY" : "M/D/YYYY h:mma");
			} else {
				return moment.unix(timestamp / 1000).format(dateOnly ? "M/D/YYYY" : "M/D/YYYY h:mma");
			}
		},
		formatDate (date) {
			if (!date) return null

			const [year, month, day] = date.split('T')[0].split('-')
			let formattedDate = `${month}/${day}/${year}`;
			//console.log(`Format - ${date} -> ${formattedDate}`);
			return formattedDate;
		},
		parseDate (date) {
			if (!date) return null

			const [month, day, year] = date.split('/')
			let parsedDateString = `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`
			//console.log(`Parse - ${date} -> ${parsedDateString}`);
			return parsedDateString;
		},
		userHasPermission(name) {
			let hasLocalPermissions = false;
			let hasOrgPermissions = false;

			if (this.vault && this.user) {
				hasLocalPermissions = !!this.vault.permissions.find(perm => perm[name] === true && perm.user_id === this.user.id && perm._deleted !== 1);

				if (this.organization && this.vault.org_id === this.organization.id) {
					if (this.cognito.attributes["custom:mutableUserType"] === "admin") {
						hasOrgPermissions = true;
					} else if (!hasLocalPermissions) {
						hasOrgPermissions = !!this.organization.permissions.find(perm => perm[name] === true && perm.user_id === this.user.id && perm._deleted !== 1);
					}
				}
			}

			return hasLocalPermissions || hasOrgPermissions;
		},
		updatingUserComment(note, file) {
			let self = this;
			vaultService.mutation("updateFileComment", {
				"file_id": file.id,
				"org_id": self.$data.vault.org_id,
				"vault_id": self.$data.vault.id,
				"comment": note
			}).then(result => {
				let now = new Date();
				vaultService.mutation("newAuditNotificationAction", {
					action: "File Comment",
					vault_id: self.vault.id,
					org_id: self.vault.org_id,
					file_id: file.id,
					filename: file.name,
					description: "Commented on file.",
					action_date: now.getTime().toString()
				}).then(notificationEmails => {
					self.setFileDownloadedBy(file);
					if (notificationEmails !== self.vault.id) {
						if (notificationEmails.indexOf("|time_suppressed") > -1) {
							//self.notification("info", "Notification email has been suppressed due to a prior notification being send to portal members within the last 30 minutes.", true);
						} else {
							self.notification("success", "Comment Notification emailed to " + notificationEmails);
						}
					}
				});
			}).catch(error => {
				console.error(JSON.stringify(error));
			});
		},
		renderFileComments(file) {
			//Get id from vault permissions.
			//Only show comments from people who current have permissions.
			//Show current user's comments first.
			return file.comments.map(comment => {
				let nameInitials = "";
				try {
					nameInitials = comment.user_name ? comment.user_name.match(/\b(\w)/g).join('') : "";
				} catch(e) {
					//console.error("Comment without initials.");
				}
				return {
					initials: nameInitials,
					name: comment.user_name,
					userId: comment.created_by,
					class: {
						"background-color": toMaterialStyle(comment.user_name).backgroundColor,
						"color": toMaterialStyle(comment.user_name).color
					},
					lastModified: parseInt(comment._lastChangedAt),
					comment: comment.comment
				};
			});
		},
		saveFileComments({file, comment, note}) {
			//console.log(`Change file ${file.name} comment from ${comment.comment} to ${note}.`);
			let files = this.vaultFiles;
			let updated = false;
			for (let i = 0; i < this.vaultFiles.length; i++) {
				if (this.vaultFiles[i].id === file.id) {
					if (!this.vaultFiles[i].comments) {
						this.vaultFiles[i].comments = [];
					}

					for (let c = 0; c < this.vaultFiles[i].comments.length; c++) {
						if (this.vaultFiles[i].comments[c].created_by === this.user.id) {
							this.vaultFiles[i].comments[c].comment = note;
							this.vaultFiles[i].comments[c].user_name = this.user.displayName;
							updated = true;
							break;
						}
					}
				}
			}
		},
		fileHasNoUserComment(file) {
			return !file.comments.find(comment => comment.created_by === this.user.id);
		},
		isVaultPendingInvitation() {
			let vaultIsPendingInvitation = false;
			let self = this;
			if (self.vault && self.cognito && self.cognito.attributes['custom:mutableUserType'] === "guest") {
				let foundPermission = self.vault.permissions.find(testPerm =>
					testPerm.user_id === self.cognito.attributes.sub &&
					testPerm.invitation_accepted === "none" && testPerm._deleted !== 1);
				if (!!foundPermission) {
					vaultIsPendingInvitation = true;
				}
			}
			return vaultIsPendingInvitation;
		},
		openRenameFileModal(file) {
			this.renameFilenameValue = file.name;
			this.modals.renameFile = true;
		},
		renameFile(file, name) {
			let self = this;
			self.progress.renameFile = true;
			let now = new Date();

			if (!name) {
				self.notification('error', "Failed to Rename file, please enter a valid filename.");
				self.progress.renameFile = false;
			} else {
				//1. Get extension from file.name
				//2. Get extension from name
				//3. If name has no extension, append extension from file.name
				if (!file.folder) {
					let nameParts = name.split('.');
					let newNameExtension = name.split('.').pop();
					if (file.extension !== "fld" && (nameParts.length < 2 || newNameExtension.length > 4)) {
						file.name = name + "." + file.extension;
						file.extension = newNameExtension;
					}
				}

				vaultService.mutation("renameFile", {
					"isFolder": file.extension === "fld" ? true : false,
					"file_id": file.id,
					"org_id": this.$data.vault.org_id,
					"vault_id": this.$data.vault.id,
					"name": name
				}).then(response => {
					self.selectedFiles = [];

					self.modals.renameFile = false;
					self.progress.renameFile = false;
					self.renameFilenameValue = "";
					self.notification('success', "File rename successful!");

					vaultService.mutation("newAuditNotificationAction", {
						action: "Rename",
						vault_id: self.$data.vault.id,
						org_id: self.$data.vault.org_id,
						file_id: file.id,
						description: "From filename " + file.name,
						filename: name,
						action_date: now.getTime().toString()
					});

					self.refreshFiles(true);
				}).catch(error => {
					vaultService._log(error);
					self.modals.renameFile = false;
					self.progress.renameFile = false;
					self.renameFilenameValue = "";
					self.notification('error', "Failed to Rename file, please ensure that you have permissions and have a file extension.");
				});
			}
		},
		clickFileThumbnail(event, item, vault) {
			event.preventDefault();
			event.stopImmediatePropagation();

			if (!item) {
				this.selectedFiles = [];
			} else if (event.ctrlKey || event.shiftKey) {
				//Add or remove from selectedFiles
				let isSelectedState = false;

				for (let f = 0; f < this.selectedFiles.length; f++) {
					if (this.selectedFiles[f].id === item.id) {
						isSelectedState = true;
						this.selectedFiles.splice(f, 1);
						break;
					}
				}
				if (isSelectedState === false) {
					this.selectedFiles.push(item);
				}
			} else {
				//Replace selectedFiles with [item]
				this.selectedFiles = [item];
			}
		},
		isSelectedFile(item) {
			let isSelectedState = false;
			for (let f = 0; f < this.selectedFiles.length; f++) {
				if (this.selectedFiles[f].id === item.id) {
					isSelectedState = true;
					break;
				}
			}

			return isSelectedState;
		},
		folderDate(timestamp) {
			if (!timestamp) {
				return "";
			} else {
				return this.momentDate(timestamp);
			}
		},
		fileSize(size) {
			let bytes = size;
			if (bytes >= 1073741824) {
				bytes = (bytes / 1073741824).toFixed(2) + " GB";
			} else if (bytes >= 1048576) {
				bytes = (bytes / 1048576).toFixed(2) + " MB";
			} else if (bytes >= 1024) {
				bytes = (bytes / 1024).toFixed(2) + " KB";
			} else if (bytes > 1) {
				bytes = bytes + " bytes";
			} else if (bytes === 1) {
				bytes = bytes + " byte";
			} else {
				bytes = "0 bytes";
			}
			return bytes;
		},
		getVaultAuditHistory() {
			this.modals.auditHistory = true;
			vaultService.query("getVaultAuditHistoryById", {
				vault_id: this.vault.id, 
				loadAuditHistory: true
			}, undefined, {vuexCache: false}).then(response => {
				// Format the audit history entries before displaying
				this.auditHistory = response.getVaultById.audit_history.map(entry => {
					if (entry.action === 'Email') {
						return {
							...entry,
							// Add formatted description while preserving original
							description_formatted: this.formatEmailContent(entry.description)
						};
					}
					return entry;
				});
			}).catch(error => {
				console.error(error);
			});
		},
		getFilenameForId(fileId) {
			let fileName = "";
			let tmpFile = this.vaultFiles.find(file => file.id === fileId);
			if (tmpFile) {
				fileName = tmpFile.name;
			}
			return fileName;
		},
		getFilesForPath(folderFileId, recursive) {
			let self = this;
			if (typeof folderFileId === "undefined") {
				folderFileId = this.currentFolderFile;
			}

			console.log(`Folder: ${folderFileId}`);

			let filesInFolder = [];

			if (this.vaultFiles) {
				let tmpFiles =
					this.vaultFiles
						.filter(file => file.parent_folder_file_id === folderFileId || (!folderFileId && !file.parent_folder_file_id));

				if (recursive) {
					for (let i = 0; i < tmpFiles.length; i++) {
						if (tmpFiles[i].extension === 'fld') {
							tmpFiles = tmpFiles.concat(self.getFilesForPath(tmpFiles[i].id, true));
						}
					}
				} else {
					tmpFiles = tmpFiles.filter(file => file.extension !== 'fld');
				}

				if (tmpFiles) {
					filesInFolder = tmpFiles;
				}
			}

			return filesInFolder;
		},
		getTypeName(ext) {
			return vaultService.getExtensionName(ext);
		},
		changeDirectory(parentFolderFile, refreshSelection) {
			if (typeof refreshSelection === 'undefined' || refreshSelection === true) {
				this.selectedFiles = [];
			}

			if (parentFolderFile && parentFolderFile.id) {
				//console.log(`Change Dir to ${parentFolderFile.name} and id ${parentFolderFile.id}`);
				this.currentFolderFile = parentFolderFile;
				document.title = "Portal: " + this.vault.name + " - " + parentFolderFile.name;
				window.history.pushState({ directory: parentFolderFile ? parentFolderFile.id : null }, document.title, `/org/${this.vault.org_id}/vault/${this.vault.id}/folder/${parentFolderFile.id}`);
				//this.$router.push(`/org/${this.vault.org_id}/vault/${this.vault.id}/folder/${parentFolderFile.id}`);
				/*
				if (window.location.pathname !== `/org/${this.vault.org_id}/vault/${this.vault.id}/folder/${parentFolderFile.id}`) {
					this.$router.push({
						name: 'Portal',
						params: {vaultid: this.vault.id, orgid: this.vault.org_id, folderid: parentFolderFile.id}
					});
				}
				 */
			} else {
				this.currentFolderFile = null;
				document.title = "Portal: " + this.vault.name;
				window.history.pushState({ directory: parentFolderFile ? parentFolderFile.id : null }, document.title, `/org/${this.vault.org_id}/vault/${this.vault.id}/folder/main`);
				//this.$router.push(`/org/${this.vault.org_id}/vault/${this.vault.id}`);
				/*
				if (window.location.pathname !== `/org/${this.vault.org_id}/vault/${this.vault.id}/folder/main`) {
					this.$router.push({name: 'Portal', params: {vaultid: this.vault.id, orgid: this.vault.org_id}});
				}
				 */
			}

			//this.displayFilesForPath = this.getFilesForPath(parentFolderFile ? parentFolderFile.id : null);

			let crumbs = [];
			if (parentFolderFile && parentFolderFile.id) {
				crumbs.push(parentFolderFile);
			}

			let seekFolderRoot = parentFolderFile && parentFolderFile.parent_folder_file_id ? parentFolderFile.parent_folder_file_id : null;
			while (seekFolderRoot) {
				let foundNextFolder = this.vaultFiles.find(file => file.extension === "fld" && file.id === seekFolderRoot);
				if (foundNextFolder) {
					crumbs.push(foundNextFolder);
					seekFolderRoot = foundNextFolder.parent_folder_file_id ? foundNextFolder.parent_folder_file_id : null;
				} else {
					seekFolderRoot = null;
				}
			}

			crumbs.push({
				name: "Home Folder",
				id: null //PATH VAR SHOULD BE REMOVED
			});

			crumbs.reverse();

			//console.log(`crumbs ${JSON.stringify(crumbs)}`);
			this.breadcrumbs = crumbs;

			//TODO: ASYNC LOAD Thumb for each in this.displayFilesForPath that hasn't already loaded.

		},
		editPermissions() {
			if (this.cognito && this.cognito.attributes['custom:mutableUserType'] !== "guest" && this.organization && this.cognito.attributes.sub === this.organization.id) {
				this.modals.manageGuestPerms = true;
			}
		},
		getFolderIdForPath(fullFilePath) {
			let self = this;
			return new Promise(async (resolve) => {
				let segments = fullFilePath.split('/');
				segments.pop();

				let getFolderIdForName = function(folderName, parentFolderId) {
					return new Promise((resolveFolder) => {
						let existingFolder = self.vaultFiles.find(file =>
							( file.parent_folder_file_id === (parentFolderId ? parentFolderId : null) || file.parent_folder_file_id === (parentFolderId ? parentFolderId : ""))
							&& file.name.toLowerCase() === folderName.toLowerCase()
							&& file.extension === "fld");

						if (!existingFolder && folderName) {
							//create folder
							self.createNewFolder(folderName, parentFolderId).then(folderId => {
								resolveFolder(folderId);
							});
						} else {
							resolveFolder(existingFolder ? existingFolder.id : null);
						}
					});
				};

				segments = segments.map(segment => { return { name: segment, folderId: null, parentFolderId: null }; });
				let lastSegment = null;
				while (segments.length) {
					let nextSegment = segments.shift();
					if (nextSegment.name !== 'Home Folder') {
						let tmpParentFileFolder = self.vaultFiles.find(file =>
							file.parent_folder_file_id === ((lastSegment.parentFolderId ? lastSegment.parentFolderId : null) || ((lastSegment.parentFolderId ? lastSegment.parentFolderId : "")))
							&& file.name.toLowerCase() === lastSegment.name.toLowerCase()
							&& file.extension === "fld");
						if (tmpParentFileFolder) {
							nextSegment.parentFolderId = tmpParentFileFolder.id;
						} else {
							console.log("No parent folder id.");
						}

						//find existing folder for this path.
						//1. find folders with same parent, 2. check names
						nextSegment.folderId = await getFolderIdForName(nextSegment.name, nextSegment.parentFolderId);
					}

					lastSegment = nextSegment;
				}

				resolve(lastSegment);
			});
		},
		updateGuestPermissions(email, valueToChange) {
			let self = this;
			//console.log(`Update ${valueToChange} permissions for ${email} on vault ${self.vault.id}`)
			vaultService.mutation("updatePerms", {
				memberEmail: email,
				valueToChange,
				vaultId: self.vault.id
			}).then(response => {
				//Commenting this out to make it more fluid, might have to check again if it becomes a problem
				//self.loadVault(true);
			}).catch(error => {
				//console.log(error);
				self.notification('error', "Unable to update guest permissions.");
			});
		},
		updateGuestName(email, newName) {
			let self = this;
			if (!newName || newName.trim() === '') {
				self.notification('error', "Guest name cannot be empty.");
				// Reload the vault to reset the name
				self.loadVault(true);
				return;
			}
			
			vaultService.mutation("updatePerms", {
				memberEmail: email,
				valueToChange: 'user_name',
				vaultId: self.vault.id,
				newValue: newName.trim()
			}).then(response => {
				self.notification('success', "Guest name updated successfully.");
			}).catch(error => {
				self.notification('error', "Unable to update guest name.");
				// Reload the vault to reset the name
				self.loadVault(true);
			});
		},
		startGuestNameEdit(item) {
			// Use Vue.set to ensure reactivity for new properties
			this.$set(item, '_editingName', true);
			this.$set(item, '_editNameValue', item.user_name);
		},
		saveGuestNameEdit(item) {
			let self = this;
			if (!item._editNameValue || item._editNameValue.trim() === '') {
				self.notification('error', "Guest name cannot be empty.");
				return;
			}
			
			vaultService.mutation("updatePerms", {
				memberEmail: item.user_email,
				valueToChange: 'user_name',
				vaultId: self.vault.id,
				newValue: item._editNameValue.trim()
			}).then(response => {
				// Update the actual name and exit edit mode
				item.user_name = item._editNameValue.trim();
				item._editingName = false;
				item._editNameValue = null;
				self.notification('success', "Guest name updated successfully.");
			}).catch(error => {
				self.notification('error', "Unable to update guest name.");
				// Exit edit mode and revert to original name
				item._editingName = false;
				item._editNameValue = null;
			});
		},
		cancelGuestNameEdit(item) {
			// Exit edit mode without saving
			item._editingName = false;
			item._editNameValue = null;
		},
		getFileLinkUrl(file) {
			let fileUrl = `${location.protocol}//${window.location.hostname}${location.port !== 443 ? (':' + location.port) : ''}/org/${this.vault.org_id}/vault/${this.vault.id}/folder/main?download=${file.id}&name=${encodeURIComponent(encodeURIComponent(file.name))}&extension=${file.extension}`;
			this.copyToClipboard(fileUrl);
			this.notification('success', `URL for file "${file.name}" has been copied to the clipboard.`);
		},
		refreshVaultToken() {
			let self = this;

			vaultService.getVaultToken(self.vault).then(response => {
				if (response.token) {
					self.$data.vaultToken = response.token;
				}
			}).catch(error => {
				self.$data.vaultToken = null;
				self.error("Invalid permissions for vault token.");
				//self.notification('error', "Invalid permissions.");
			});
		},
		pathFromParentFolderId(parentFolderId) {
			let path = "/";
			let tmpId = parentFolderId;
			try {
				while (tmpId) {
					let tmpFileEntry = this.vaultFiles.find(file => file.id === tmpId);
					if (tmpFileEntry) {
						path = "/" + tmpFileEntry.name + path;
						let tmpTmpId = tmpFileEntry && tmpFileEntry.parent_folder_file_id ? tmpFileEntry.parent_folder_file_id : null;
						tmpId = tmpTmpId !== tmpId ? tmpTmpId : null;
					} else {
						tmpId = null;
					}
				}
			} catch (e) {
				tmpId = null;
				console.dir(e);
			}

			if (path === "/" && this.vault) {
				path = this.vault.name;
			}

			return path;
		},
		copyToClipboard(str) {
			const el = document.createElement('textarea');  // Create a <textarea> element
			el.value = str;                                 // Set its value to the string that you want copied
			el.setAttribute('readonly', '');                // Make it readonly to be tamper-proof
			el.style.position = 'absolute';
			el.style.left = '-9999px';                      // Move outside the screen to make it invisible
			document.body.appendChild(el);                  // Append the <textarea> element to the HTML document
			const selected =
				document.getSelection().rangeCount > 0        // Check if there is any content selected previously
					? document.getSelection().getRangeAt(0)     // Store selection if found
					: false;                                    // Mark as false to know no selection existed before
			el.select();                                    // Select the <textarea> content
			document.execCommand('copy');                   // Copy - only works as a result of a user action (e.g. click events)
			document.body.removeChild(el);                  // Remove the <textarea> element
			if (selected) {                                 // If a selection existed before copying
				document.getSelection().removeAllRanges();    // Unselect everything on the HTML document
				document.getSelection().addRange(selected);   // Restore the original selection
			}
		},
	loadVault(skipToken) {
		let self = this;
		vaultService.query("getVaultById", {vault_id: self.$route.params.vaultid,loadAuditHistory: false}, undefined, {vuexCache: false}).then(vault => {
			if(vault === "DELETED_VAULT"){
				self.error("Portal is Deleted.");
				self.notification('error', "Portal has been Deleted.");
				self.$router.push('/vaults');
			}
			//DONE: Set org id in state.
			if (self.cognito && self.cognito.attributes["custom:mutableUserType"] === "guest") {
				self.organizationId = vault.org_id;
				EventBus.$emit("refreshlazy", {oldId: "", newId: self.organizationId});
			}

		self.memberVaultPerms = [];
		self.originalVaultName = vault.name;

			//userVaultPermissions
			let existingMemberVaultPerms = null;
			if (vault) {
				existingMemberVaultPerms = vault.permissions.find(vPerm => self.cognito.attributes.sub === vPerm.user_id && vPerm._deleted !== 1);
				if (existingMemberVaultPerms) {
					self.userVaultPermissions.view_files = existingMemberVaultPerms.view_files;
					self.userVaultPermissions.upload_files = existingMemberVaultPerms.upload_files;
					self.userVaultPermissions.rename_files = existingMemberVaultPerms.rename_files;
					self.userVaultPermissions.delete_files = existingMemberVaultPerms.delete_files;
					self.userVaultPermissions.manage_perms = existingMemberVaultPerms.manage_perms;
					self.userVaultPermissions.create_vault = existingMemberVaultPerms.create_vault;
					self.userVaultPermissions.access_vault = existingMemberVaultPerms.access_vault;
				}
			}

			self.$data.vault = vault;
			
			// Ensure workflow state name is synced with ID if missing
			// This must happen AFTER vault is assigned so computed properties work correctly
			if (vault.workflowStateId && (!vault.workflowStateName || vault.workflowStateName === 'Not Set')) {
				self.$nextTick(() => {
					self.syncWorkflowStateName(vault);
				});
			}

				// Initialize tags for editing
				if (!Array.isArray(self.$data.vault.tags)) {
					self.$data.vault.tags = [];
				}
				self.$data.vault._editTagsArray = [...self.$data.vault.tags];

				
				//For each permission on the organization.permissions...
				if (self.organization) {
					for (let i = 0; i < self.organization.permissions.length; i++) {
						let orgPermission = self.organization.permissions[i];

						if (existingMemberVaultPerms && self.cognito.attributes.sub === orgPermission.user_id) {
							orgPermission.upload_notification = orgPermission.upload_notification || !!existingMemberVaultPerms.upload_notification;
							orgPermission.download_notification = orgPermission.download_notification || !!existingMemberVaultPerms.download_notification;
						} else {
							orgPermission.upload_notification = false;
							orgPermission.download_notification = false;
						}

						if (orgPermission.user_id === self.cognito.attributes.sub) {
							self.userVaultPermissions.view_files = self.userVaultPermissions.view_files || orgPermission.view_files;
							self.userVaultPermissions.upload_files = self.userVaultPermissions.upload_files || orgPermission.upload_files;
							self.userVaultPermissions.rename_files = self.userVaultPermissions.rename_files || orgPermission.rename_files;
							self.userVaultPermissions.delete_files = self.userVaultPermissions.delete_files || orgPermission.delete_files;
							self.userVaultPermissions.create_vault = self.userVaultPermissions.create_vault || orgPermission.create_vault;
							self.userVaultPermissions.access_vault = self.userVaultPermissions.access_vault || orgPermission.access_vault;
						}

						self.memberVaultPerms.push(orgPermission);
					}

					try {
						woopra.identify({Company: self.organization.companyName});
					} catch (error) {
						console.log("Unable to track comapny name.")
					}
				}

				document.title = "Portal: " + vault.name;

				if (skipToken !== true) {
					vaultService.getVaultToken(vault).then(response => {
						if (response.token) {
							//self.debug(`Got portal token.`);
							//self.debug(token);
							self.$data.vaultToken = response.token;
							self.$data.thumbBucket = response.awsMobile.aws_user_thumbs_s3_bucket;

							//Flag need to accept terms, set terms, check user for terms accepted
							if (!self.user.acceptedTermVaults || self.user.acceptedTermVaults.indexOf(self.vault.id) < 0) {
								if (response.token.termsEnforced === true
									&& (self.cognito.attributes["custom:mutableUserType"] === "guest" || self.user.memberOf !== self.vault.org_id)) {
									//alert(response.token.termsAndConditions);
									self.termsAndConditions = response.token.termsAndConditions;
									self.termsDialog = true;
								}
							}

							if (self.$data.tokenRefreshTimer) {
								clearInterval(self.$data.tokenRefreshTimer);
							}

							self.$data.tokenRefreshTimer = setInterval(function() {
								self.refreshVaultToken();
							}, 1200000);

							//TODO: Check url parameters to download file.
							if (self.$route.query.download) {
								let downloadFile = {
									id: self.$route.query.download,
									name: self.$route.query.name,
									extension: self.$route.query.extension
								};

								window.history.replaceState({}, document.title, `/org/${self.vault.org_id}/vault/${self.vault.id}/folder/main`);

								try{
									downloadFile.name = decodeURIComponent(downloadFile.name);
									self.selectFileToPreview(downloadFile,self.vault);
								}catch (e) {
									console.log("Trying to open file from URL : " + JSON.stringify(e));
									self.notification("error", "Unable to open file, please try again.");
								}
								/*vaultService.downloadSignedFile(vault, downloadFile).then(() => {
									self.setFileDownloadedBy(downloadFile);
								}).catch(error => {
									//console.log(JSON.stringify(error));
									self.notification("error", "Unable to download file, please try again.");
								});*/
							}

					vaultService.query("getTasksByVaultId", {vault_id: self.vault.id}, undefined, {vuexCache: false}).then(response => {
						self.vaultTasks = response;
						if (self.numberOfOpenTasks > 0 && self.vault && self.vault.orgTier && (self.vault.orgTier === 'enterprise' || self.vault.orgTier === 'large firm')) {
							self.viewMode = 1;
						} else {
							self.viewMode = 0;
						}
						self.getTasksForCalendar();
					}).catch(error => {
								console.error(error);
							});

							self.refreshFiles(true, false, self.$route.params.folderid !== "main" ? self.$route.params.folderid : null, true);
						} else {
							self.error("Invalid permissions for vault token.");
							self.notification('error', "Invalid permissions.");

							self.refreshFiles(true, false, self.$route.params.folderid !== "main" ? self.$route.params.folderid : null, true);
						}
					}).catch(error => {
						self.$data.vaultToken = null;
						self.error("Error: Invalid Permissions to access portal.");
						//self.notification('error', "Invalid permissions.");

						self.refreshFiles(true, false, self.$route.params.folderid !== "main" ? self.$route.params.folderid : null, true);
					});

					vaultService.mutation("newAuditNotificationAction", {
						action: "Open Portal",
						vault_id: self.vault.id,
						org_id: self.vault.org_id,
						description: "Portal accessed by user.",
						action_date: (new Date()).getTime().toString()
					});
				}
			}).catch(error => {
				if(error.message === "GraphQL error: DELETED_VAULT"){
					self.error("Portal is Deleted.");
					self.notification('error', "Portal has been Deleted.");
				}else{
					self.error("Unable to get vault by id.");
					self.notification('error', "Unable to access portal.");
				}
				self.$router.push('/vaults');
			});
		},
		extensionIcon(ext) {
			let icon = "fa fa-file";
			if (ext) {
				switch (ext.toLowerCase()) {
					case "doc":
					case "docx":
						icon = "fas fa-file-word";
						break;
					case "pdf":
						icon = "fas fa-file-pdf";
						break;
					case "txt":
						icon = "fas fa-file-alt";
						break;
					case "fld":
						icon = "fas fa-folder";
						break;
					case "url":
						icon = "fas fa-external-link-alt";
						break;
					case "jpg":
					case "jpeg":
					case "gif":
					case "png":
					case "tif":
					case "tiff":
					case "bmp":
					case "eps":
					case "svg":
					case "webp":
						icon = "fas fa-file-image";
						break;
					case "mp4":
					case "mpg":
					case "mov":
					case "m4v":
						icon = "fas fa-file-video";
						break;
					case "mp3":
					case "wav":
					case "aif":
						icon = "fas fa-file-audio";
						break;
					case "pptx":
					case "ppt":
						icon = "fas fa-file-powerpoint";
						break;
					case "xlsx":
					case "xls":
						icon = "fas fa-file-excel";
						break;
					default:
						icon = "fas fa-file";
						break;
				}
			}
			return icon;
		},
		retryFileFromQueue(fileId) {
			console.log(`Retry file from queue ${fileId}`);
			for (let sf = 0; sf < this.uploadFileQueue.length; sf++) {
				if (this.uploadFileQueue[sf].upload.uuid === fileId) {
					//this.debug(`Set file from queue to RETRY ${this.uploadFileQueue[sf].name}`);
					console.log(`Set file from queue to RETRY ${this.uploadFileQueue[sf].entry.name}`);
					this.uploadFileQueue[sf].status = "retry";
					break;
				}
			}
		},
		editVaultName() {
			this.vaultNameEditing = true;
			setTimeout(() => {
				if (document.getElementById("vault-name")) {
					document.getElementById("vault-name").focus();
				}
			}, 100);

		},
		updateVaultName() {
			let self = this;
			if (self.vault) {
				let existingVaultName = self.vaults.find(vault => vault.name.toLowerCase().trim() === self.vault.name.toLowerCase().trim() && vault.id !== self.vault.id);
				
				if (!existingVaultName) {
					vaultService.mutation("updateVaultSettings", {
						"vault_id": self.$data.vault.id,
						"org_id": self.$data.vault.org_id,
						"name": self.vault.name,
						"archived": Boolean(self.vault.archived) || false,
						"private_mode": Boolean(self.vault.private_mode) || false,
						"hide_perms": Boolean(self.vault.hide_perms) || false,
						"isTemplate": Boolean(self.vault.isTemplate) || false
					}).then(() => {
						self.notification('success', "Portal name updated.");
						self.originalVaultName = self.vault.name;
					}).catch(error => {
						self.notification('error', "Unable to rename portal.");
						self.vault.name = self.originalVaultName;
					});
				} else {
					self.notification('error', "Unable to rename portal.");
					self.vault.name = self.originalVaultName;
				}
			}
		},
		updateVaultHidePerms(){
			let self = this;
			if (self.vault) {
				vaultService.mutation("updateVaultSettings", {
					"vault_id": self.$data.vault.id,
					"org_id": self.$data.vault.org_id,
					"hide_perms": !!self.vault.hide_perms,
					"archived": Boolean(self.vault.archived) || false,
					"private_mode": Boolean(self.vault.private_mode) || false,
					"isTemplate": Boolean(self.vault.isTemplate) || false
				}).then(() => {
					self.loadVault();
					self.notification('success', "Portal hide permissions changed.");
				}).catch(error => {
					self.notification('error', "Unable to update portal hide permissions.");
					self.vault.hide_perms = !self.vault.hide_perms;
				});
			}
		},
		updateVaultPrivateMode() {
			let self = this;
			if (self.vault) {
				vaultService.mutation("updateVaultSettings", {
					"vault_id": self.$data.vault.id,
					"org_id": self.$data.vault.org_id,
					"private_mode": !!self.vault.private_mode,
					"archived": Boolean(self.vault.archived) || false,
					"hide_perms": Boolean(self.vault.hide_perms) || false,
					"isTemplate": Boolean(self.vault.isTemplate) || false
				}).then(() => {
					self.notification('success', "Portal privacy mode updated.");
				}).catch(error => {
					self.notification('error', "Unable to update portal privacy mode.");
					self.vault.private_mode = !self.vault.private_mode;
				});
			}
		},
		updateVaultArchiveStatus() {
			let self = this;
			if (self.vault) {
				vaultService.mutation("updateVaultSettings", {
					"vault_id": self.$data.vault.id,
					"org_id": self.$data.vault.org_id,
					"archived": !!self.vault.archived,
					"private_mode": Boolean(self.vault.private_mode) || false,
					"hide_perms": Boolean(self.vault.hide_perms) || false,
					"isTemplate": Boolean(self.vault.isTemplate) || false
				}).then(() => {
					self.notification('success', "Portal archive status updated.");
				}).catch(error => {
					self.notification('error', "Unable to update portal archive status.");
					self.vault.archived = !self.vault.archived;
				});
			}
		},
		updateVaultTemplateStatus() {
			let self = this;
			if (self.vault) {
				vaultService.mutation("updateVaultSettings", {
					"vault_id": self.$data.vault.id,
					"org_id": self.$data.vault.org_id,
					"isTemplate": !!self.vault.isTemplate,
					"archived": Boolean(self.vault.archived) || false,
					"private_mode": Boolean(self.vault.private_mode) || false,
					"hide_perms": Boolean(self.vault.hide_perms) || false
				}).then(() => {
					self.notification('success', "Portal template status updated.");
				}).catch(error => {
					self.notification('error', "Unable to update portal template status.");
					self.vault.isTemplate = !self.vault.isTemplate;
				});
			}
		},
syncWorkflowStateName(vault) {
	// Helper method to ensure workflowStateName is synced with workflowStateId
	// This provides resilience when the name field is missing but ID is present
	let self = this;
	
	if (!vault || !vault.workflowStateId) {
		return;
	}
	
	// Determine which workflow states array to use
	let workflowStates = [];
	if (self.organization && self.organization.workflowStates && self.organization.workflowStates.length > 0) {
		workflowStates = self.organization.workflowStates;
	} else if (vault.orgWorkflowStates && vault.orgWorkflowStates.length > 0) {
		workflowStates = vault.orgWorkflowStates;
	}
	
	if (workflowStates.length === 0) {
		return;
	}
	
	// Look up the name from the ID
	const state = workflowStates.find(s => s.id === vault.workflowStateId);
	if (state && state.name) {
		// Update the vault object with the looked-up name using Vue.set for reactivity
		self.$set(vault, 'workflowStateName', state.name);
	}
},
	
	updateVaultWorkflowState() {
		let self = this;
		if (self.vault && self.organization && self.organization.workflowStatesEnabled) {
			// Find the current workflow state name
			let workflowStateName = null;
			let workflowStateId = self.vault.workflowStateId;
			
			if (workflowStateId && self.organization.workflowStates) {
				const currentState = self.organization.workflowStates.find(state => state.id === workflowStateId);
				workflowStateName = currentState ? currentState.name : null;
			}
			
			// If workflowStateId is null (cleared), also clear the name
			if (workflowStateId === null || workflowStateId === undefined) {
				workflowStateName = null;
			}
			
			vaultService.mutation("updateVaultSettings", {
				"vault_id": self.$data.vault.id,
				"org_id": self.$data.vault.org_id,
				"workflowStateId": workflowStateId,
				"workflowStateName": workflowStateName,
				"archived": Boolean(self.vault.archived) || false,
				"private_mode": Boolean(self.vault.private_mode) || false,
				"hide_perms": Boolean(self.vault.hide_perms) || false,
				"isTemplate": Boolean(self.vault.isTemplate) || false
			}).then(() => {
				// Update the local vault object with the new workflow state name
				self.vault.workflowStateName = workflowStateName;
				if (workflowStateName) {
					self.notification('success', "Portal workflow status updated to: " + workflowStateName);
				} else {
					self.notification('success', "Portal workflow status cleared.");
				}
			}).catch(error => {
				self.notification('error', "Unable to update portal workflow status.");
				console.error("Error updating workflow state:", error);
			});
		}
	},
		clearSelectedFiles() {
			this.selectedFiles = [];
		},
		hasPendingUploads() {
			return !!this.uploadFileQueue.find(file => file.status === "queued");
		},
		doubleCheckUploadStatus() {
			//this.debug("Run upload status checker..");
			let self = this;
			if (!self.uploadRunnerTimer) {
				self.uploadRunnerTimer = setInterval(self.doubleCheckUploadStatus, 5000);
			}

			if (self.queuePaused === false) {
				if (self.uploadInProgress !== true && self.uploadFileQueue.length > 0) {
					//self.debug("Double Check the Upload Queue status.");
					self.uploadFiles();
				} else if (self.uploadInProgress === true && self.uploadFileQueue.length === 0) {
					self.uploadInProgress = false;
				}

				let now = new Date();

				let foundPending = false;
				if (self.uploadFileQueue.length > 0) {
					for (let f = 0; f < self.uploadFileQueue.length; f++) {
						if (self.uploadFileQueue[f].status === "done") {
							try {
								/*let afterSeconds = new Date(self.uploadFileQueue[f].upload.completedAt.getTime() + 15000);
								if (now > afterSeconds) { //timeout after 15 seconds
									self.uploadFileQueue.splice(f, 1);
									f = 0;
								}*/
							} catch (exception) {
								self.error("Unable to parse file upload completion date.");
							}
						} else if (self.uploadFileQueue[f].status !== "done" && self.uploadFileQueue[f].status !== "error") {
							foundPending = true;
						}
					}
				}

				if (foundPending === true && self.uploadInProgress === false) {
					self.uploadFiles();
				}
			}
		},
		// Helper to fetch all file pages using the paginated API
		async fetchAllFilePages(vaultId, showDeleted, accumulatedFiles, nextToken) {
			let self = this;
			accumulatedFiles = accumulatedFiles || [];
			
			let queryParams = {
				vault_id: vaultId,
				show_deleted: showDeleted,
				limit: 1500
			};
			if (nextToken) {
				queryParams.nextToken = nextToken;
			}
			
			let result = await vaultService.query("getFilesByVaultIdPaginated", queryParams, undefined, {vuexCache: false});
			
			// Handle paginated response structure
			let items = result && result.items ? result.items : [];
			let responseNextToken = result && result.nextToken ? result.nextToken : null;
			
			accumulatedFiles = accumulatedFiles.concat(items);
			
			if (responseNextToken) {
				return self.fetchAllFilePages(vaultId, showDeleted, accumulatedFiles, responseNextToken);
			}
			
			return accumulatedFiles;
		},
		refreshFiles(stayPut, showDeleted, folderFileId, markUnreadSelected, includeTasks) {
			let self = this;
			if (typeof showDeleted === "undefined") {
				showDeleted = false;
			}
			self.showingDeleted = showDeleted;

			if (self.userVaultPermissions.view_files) {
				// Use paginated API to avoid "Transformation too large" error
				self.fetchAllFilePages(this.$data.vault.id, showDeleted, [], null).then(filesResult => {
					self.vaultFiles = filesResult; //.filter(file => file._deleted !== 1); //TODO: Duplicate key found?!
					self.loadingFiles = false;
					if (self.$data.fileRefreshTimer) {
						clearInterval(self.$data.fileRefreshTimer);
					}


					self.$data.fileRefreshTimer = setInterval(function() {
						self.refreshFiles(true, false, undefined, undefined, true);
					}, 120000);
					if (filesResult) {
						for (let f = 0; f < filesResult.length; f++) {
							let existingCommentByUser = filesResult[f].comments.find(comment => comment.created_by === this.user.id);
							if (existingCommentByUser) {
								self.comments[filesResult[f].id] = existingCommentByUser.comment;
							}
						}
					}

					if (markUnreadSelected) {
						self.selectUnreadFiles();
					}

					if (stayPut !== true) {
						self.changeDirectory();
					} else {
						if (folderFileId) {
							self.currentFolderFile = self.vaultFiles.find(file => file && file.id === folderFileId);
						}
						self.changeDirectory(self.currentFolderFile, false);
					}

					if (includeTasks) {
						vaultService.query("getTasksByVaultId", {vault_id: self.vault.id}, undefined, {vuexCache: false}).then(response => {
							self.vaultTasks = response;
							if (self.numberOfOpenTasks > 0 && self.vault && self.vault.orgTier && (self.vault.orgTier === 'enterprise' || self.vault.orgTier === 'large firm')) {
								self.viewMode = 1;
							} else {
								self.viewMode = 0;
							}
							self.getTasksForCalendar();
						}).catch(error => {
							console.error(error);
						});
					}
				}).catch(filesError => {
					self.error("Unable to read vault files. " + JSON.stringify(filesError));
					this.notification('error', "Unable to read vault files.");
				});
			} else {
				self.vaultFiles = [];
				self.loadingFiles = false;

				if (self.$data.fileRefreshTimer) {
					clearInterval(self.$data.fileRefreshTimer);
				}
			}
		},
		filterFilesOnSearch(value, search, item) {
			return value != null &&
				search != null &&
				typeof value === 'string' &&
				(item.extension !== "fld" && item._deleted !== 1) &&
				value.toString().toLowerCase().indexOf(search.toLowerCase()) !== -1;
		},
		addInviteField(index) {
			this.invitees.push({email: "", name: ""});
		},
		removeInviteField(index) {
			this.invitees.splice(index, 1);
		},
		revokeVaultInvite(email) {
			//TEST: Remove member from vault.permissions
			let self = this;
			vaultService.mutation("updatePerms", {
				memberEmail: email,
				valueToChange: "revoke",
				vaultId: self.vault.id
			}).then(response => {
				for (let i = 0; i < self.vault.permissions.length; i++) {
					if (self.vault.permissions[i].user_email.toLowerCase() === email.toLowerCase())
						self.vault.permissions[i]._deleted = 1;
				}
			}).catch(error => {
				//console.log(error);
				self.notification('error', "Unable to revoke guest permissions.");
			});
		},
		validateEmail(email) {
			let self = this;
			let error = null;
			//check for validationError based both on existing email and valid email address format.
			let existingGuestPermissions = self.vault.permissions.find(perm => perm._deleted !== 1 && perm.user_email.toLowerCase() === email.toLowerCase());
			if (existingGuestPermissions) {
				error = `A guest with the email address ${existingGuestPermissions.user_email} already exists, please remove or update this invitation.`;
			} else if (!email.match(/^[^\s@]+@[^\s@]+\.[^\s@]+$/)) {
				error = "Invalid email address.";
			}
			return error;
		},
		sendVaultInvite(name, email,isResend) {
			let self = this;
			this.invitationLoading = true;
			this.progress.resendInvitation = true;
			let guests = [];
			let emailList = [];
			let nameList = [];
			let invalidData = false;
			let validationError = null;

			if (name && email) {
				name = name.trim();
				email = email.trim();
				guests.push(`<${name}> ${email}`);
				emailList.push(email.toLowerCase());
				nameList.push(name);
				if(!isResend){
					validationError = self.validateEmail(email);
				}

			} else {
				for (let i = 0; i < self.invitees.length; i++) {
					let invitee = self.invitees[i];
					if (!invitee.name || !invitee.email) {
						invalidData = true;
						break;
					} else {
						invitee.name = invitee.name.trim();
						invitee.email = invitee.email.trim().toLowerCase();

						let existingGuestPermissions = null;
						for (let g = 0; g < self.vault.permissions.length; g++) {
							if (self.vault.permissions[g].user_email.toLowerCase() === invitee.email && self.vault.permissions[g]._deleted !== 1) {
								existingGuestPermissions = self.vault.permissions[g];
								break;
							}
						}

						if (existingGuestPermissions) {
							validationError = `A guest with the email address ${existingGuestPermissions.user_email} already exists, please remove or update this invitation.`;
							break;
						} else {
							validationError = self.validateEmail(invitee.email);
							if(validationError){
								break;
							}
						}
						guests.push(`<${invitee.name}> ${invitee.email}`);
						emailList.push(invitee.email);
						nameList.push(invitee.name);
					}
				}
			}

			if (validationError) {
				this.invitationLoading = false;
				this.progress.resendInvitation = false;
				this.notification("error", validationError);
			} else if (invalidData === true) {
				this.invitationLoading = false;
				this.progress.resendInvitation = false;
				this.notification("error", "Name and Email are both required fields for an invitation.");
			} else {
				if (guests.length === 0) {
					alert("No guest information available.");
					this.invitationLoading = false;
					this.progress.resendInvitation = false;
				} else {
					let orgLogo = this.organization.logo_s3_path ? this.organization.logo_s3_path : "zapa";
					//console.log("ORG LOGO PATH : " + orgLogo);
					vaultService.mutation("inviteNewGuest", {
						guestEmail: guests.join(";"),
						emailList,
						nameList,
						vaultId: this.vault.id,
						logo: orgLogo
					}).then(response => {
						this.invitationLoading = false;
						this.progress.resendInvitation = false;
						this.modals.inviteGuests = false;
						if (response) {
							try {
								woopra.track("New Guest Invited", {Vault: self.vault.id, OrgId: self.vault.org_id});
							} catch (woopraError) {
								console.error("Woopra not loaded.");
							}

							let now = new Date();
							vaultService.mutation("newAuditNotificationAction", {
								action: "Invite Guest",
								vault_id: self.vault.id,
								org_id: self.vault.org_id,
								description: "Invite guest " + guests.join(";"),
								action_date: now.getTime().toString()
							});

							this.invitees = [{
								email: "",
								name: ""
							}];
							this.notification("success", "Invitation(s) sent!");
							this.loadVault(true);
						}
					}).catch(error => {
						this.invitationLoading = false;
						this.progress.resendInvitation = false;
						this.error(error);
						this.notification("error", "Failed to send Invitation(s).")
					});
				}
			}
			//TODO: Figure out how to layout schema to accept an array of emails as strings
		},
		deleteFile(files) {
			let self = this;
			self.progress.deleteConfirmation = true;

			//If one of the selected files is a folder, get all files recusively within the folder.

			let fileArray = [];
			let fileIds = [];
			if (Array.isArray(files)) {
				for (let i = 0; i < files.length; i++) {
					if (files[i].extension === "fld") { //FOLDER
						let folderFiles = this.getFilesForPath(files[i].id, true);
						if (folderFiles) {
							for (let f = 0; f < folderFiles.length; f++) {
								fileArray.push({id: folderFiles[f].id, name: folderFiles[f].name});
								fileIds.push(folderFiles[f].id);
							}
						}
					}
					fileArray.push({id: files[i].id, name: files[i].name});
					fileIds.push(files[i].id);
				}
			} else {
				fileArray = [{id: files.id, name: files.name}];
				fileIds = [files.id];
			}

			let now = new Date();

			vaultService.mutation("deleteFile", {
				file_id: fileIds,
				vault_id: self.$data.vault.id,
				org_id: self.$data.vault.org_id
			}).then(response => {
				let self = this;
				self.selectedFiles = [];
				console.log("File delete completed.");
				self.notification("success", "File(s) deleted!");
				self.modals.deleteConfirmation = false;
				self.progress.deleteConfirmation = false;

				self.fetchAllFilePages(self.$data.vault.id, false, [], null).then(filesResult => {
					self.vaultFiles = filesResult;
					self.loadingFiles = false;
					if (filesResult) {
						for (let f = 0; f < filesResult.length; f++) {
							let existingCommentByUser = filesResult[f].comments && filesResult[f].comments.find ? filesResult[f].comments.find(comment => comment.created_by === self.user.id) : null;
							if (existingCommentByUser) {
								self.comments[filesResult[f].id] = existingCommentByUser.comment;
							}
						}
					}

					self.refreshFiles(true);

					Promise.all(fileArray.map(fileInfo => {
						vaultService.mutation("newAuditNotificationAction", {
							action: "Delete",
							vault_id: self.$data.vault.id,
							org_id: self.$data.vault.org_id,
							file_id: fileInfo.id,
							filename: fileInfo.name,
							action_date: now.getTime().toString()
						});
					}));
				}).catch(filesError => {
					self.modals.deleteConfirmation = false;
					self.progress.deleteConfirmation = false;
					self.error("Unable to read vault files.");
				});
			}).catch(deleteError => {
				self.modals.deleteConfirmation = false;
				self.progress.deleteConfirmation = false;
				self.error("Unable to delete file.");
				self.notification("error", "Unable to delete file(s).")
			});
		},
		removeFileFromQueue(fileId) {
			console.log(`Remove file from queue ${fileId}`);
			for (let sf = 0; sf < this.uploadFileQueue.length; sf++) {
				let selectedFile = this.uploadFileQueue[sf];
				if (selectedFile.upload.uuid === fileId) {
					console.log(`Removed file from queue ${selectedFile.name}`);
					this.uploadFileQueue.splice(sf, 1);
					break;
				}
			}
		},
		openCreateFolderPopup() {
			this.newFolderName = "";
			this.openPopup('createFolder');
		},
		async createFolder(forceFolderName, forceParentFolderId) {
			return new Promise((resolve, reject) => {
				let self = this;
				let tmpFolderName = forceFolderName ? forceFolderName : self.newFolderName;
				this.progress.createFolder = true;
				//DONE: Check for existing folder here.
				let currentFolderId = self.currentFolderFile ? self.currentFolderFile.id : null;
				if (forceParentFolderId) {
					currentFolderId = forceParentFolderId;
				}

				let existingFolderPath = self.vaultFiles.find(file =>
					file.extension === "fld" &&
					file.parent_folder_file_id === currentFolderId &&
					file.name.toLowerCase() === tmpFolderName.toLowerCase()
				);

				if (!existingFolderPath) {
					vaultService.mutation("fileUploaded", {
						id: self.uuid(),
						filename: tmpFolderName,
						extension: "fld",
						size: 0,
						parent_folder_file_id: currentFolderId,
						vault_id: self.vault.id,
						org_id: self.vault.org_id
					}).then(newFolderResponse => {
						//console.log("Folder Created.");
						self.progress.createFolder = false;
						newFolderResponse.folder = true;
						self.dialogs["createFolder"].isOpen = false;
						self.refreshFiles(true);
						resolve(newFolderResponse.id);
					}).catch(uploadError => {
						self.progress.createFolder = false;
						self.error(uploadError);
						reject(uploadError);
					});
				} else {
					self.progress.createFolder = false;
					if (!forceFolderName) {
						alert(tmpFolderName + " already exists. Please enter a unique folder name.");
					}
					
					resolve(existingFolderPath.id);
				}
			});
		},
		createNewFolder(folderName, parentFolderId) {
			let self = this;
			return new Promise((resolve, reject) => {
				let newFolderId = self.uuid();
				let newFolder = {
					id: newFolderId,
					filename: folderName,
					extension: "fld",
					size: 0,
					parent_folder_file_id: parentFolderId,
					vault_id: self.vault.id,
					org_id: self.vault.org_id
				};
				vaultService.mutation("fileUploaded", newFolder).then(newFolderReponse => {
					newFolderReponse.folder = true;
					self.vaultFiles.push(newFolderReponse);
					resolve(newFolderId); //TODO: Needs to return a File
				}).catch(uploadError => {
					reject(uploadError);
				});
			});
		},
		downloadFile(fileShell, vault, navigateUrl, returnUrl) {
			let self = this;
			let proceedWithDownload = false;
			if (self.pdfViewerFormDirty) {
				if (confirm("Warning, this PDF has unsaved changes! Do you want to download a copy of the last saved version?") === true) {
					proceedWithDownload = true;
				}
			} else {
				proceedWithDownload = true;
			}

			if (proceedWithDownload) {
				if (fileShell.extension === "fld") {
					this.changeDirectory(fileShell);
				} else {
					if (navigateUrl) {
						try {
							vaultService.downloadFile(vault, fileShell, this.$data.vaultToken.Credentials, true).then(data => {
								let lines = atob(data.Body).split("\n");
								let foundInternetShortcut = false;
								let url = null;

								for (let l = 0; l < lines.length; l++) {
									let line = lines[l];
									if (line.indexOf("[InternetShortcut]") > -1) {
										foundInternetShortcut = true;
									} else if (foundInternetShortcut) {
										url = line.trim().replace("URL=", "");
										break;
									}
								}


								if (url && returnUrl) {
									self.selectedFileUrlTarget = url;
								} else if (url) {
									window.open(url, '_blank');//.focus();
								} else {
									throw new Error("Unable to read url from bookmark.");
								}
							});
						} catch (serviceError) {
							//console.log(JSON.stringify(serviceError));
							self.notification("info", "Unable to open bookmark, downloading bookmark.");

							vaultService.downloadSignedFile(vault, fileShell).then(() => {
								self.setFileDownloadedBy(fileShell);
							}).catch(error => {
								//console.log(JSON.stringify(error));
								self.notification("error", "Unable to download file, please try again.");
							});
						}
					} else {
						vaultService.downloadSignedFile(vault, fileShell).then(() => {
							self.setFileDownloadedBy(fileShell);
						}).catch(error => {
							//console.log(JSON.stringify(error));
							self.notification("error", "Unable to download file, please try again.");
						});
					}
					/*
                    vaultService.downloadFile(vault, fileShell, this.$data.vaultToken.Credentials).then(result => {
                        this.log("Download complete for file: " + fileShell.id);
                    }).catch(downloadError => {
                        this.error("Unable to download file: " + fileShell.id);
                    });
                    */
				}
			}
		},
		downloadSelectedFiles(vault, overrideSelectedFilesWithRecentSelected) {
			let self = this;
			//for each selectedFile, if folder, then get all files within folder recursively and collect in final list
			let filesToDownload = [];

			if (self.recentActivitySelected && overrideSelectedFilesWithRecentSelected) {
				self.progress.recentActivityDownloading = true;
				for (let x in self.recentActivitySelected) {
					if (self.recentActivitySelected[x] === true) {
						let tmpFile = self.vaultFiles.find(file => file.id === x);
						if (tmpFile) {
							filesToDownload.push(tmpFile);
						}
					}
				}
			} else {
				for (let i = 0; i < self.selectedFiles.length; i++) {
					let selectedFile = self.selectedFiles[i];
					if (selectedFile.extension === 'fld') {
						filesToDownload = filesToDownload.concat(self.getFilesForPath(selectedFile.id, true));
					} else {
						filesToDownload.push(selectedFile);
					}
				}
			}

			filesToDownload = filesToDownload.filter(file => file.extension !== 'fld');

			if (filesToDownload.length === 1) {
				vaultService.downloadSignedFile(vault, filesToDownload[0]).then(() => {
					self.setFileDownloadedBy(filesToDownload[0]);
				}).catch(error => {
					//console.log(JSON.stringify(error));
					self.notification("error", "Unable to download file, please try again.");
				});
			} else {
				self.downloadProgress.inProgress = true;
				self.openPopup("downloadZipProgress", self.downloadProgress);
				self.downloadProgress.num_total = filesToDownload.length;
				self.downloadProgress.num_downloaded = 0;

				Promise.all(filesToDownload.map(file =>
					vaultService.downloadFile(vault, file, this.$data.vaultToken.Credentials, true)))
					.then(downloadedFiles => {
						self.progress.recentActivityDownloading = false;
						self.downloadProgress.inProgress = false;
						self.closePopup("downloadZipProgress");
						console.log(downloadedFiles.length + " files downloaded.");

						let zip = new JSZip();
						for (let f = 0; f < downloadedFiles.length; f++) {
							zip.file(downloadedFiles[f].name, downloadedFiles[f].Body, {base64: true});
						}

						zip.generateAsync({type: "blob"}).then(function(content) {
							FileSaver.saveAs(content, "Zapa File Download.zip");
							for (let f = 0; f < filesToDownload.length; f++) {
								self.setFileDownloadedBy(filesToDownload[f]);
							}
						});
					}).catch(error => {
					self.error("Unable to download files: " + JSON.stringify(error));
					self.progress.recentActivityDownloading = false;
				});
			}
		},
		getS3KeyForThumbnail(fileShell, vault) {
			return `thumbnails/${vault.org_id}/${vault.id}/${fileShell.id}`;
		},
		validThumbnailExtension(fileShell) {
			let validThumbnail = false;
			if (fileShell && fileShell.extension) {
				validThumbnail = ALLOWED_FILETYPES.indexOf(fileShell.extension.toLowerCase()) > -1;
			}
			return validThumbnail;
		},
		signOutUser() {
			this.cache = {};
			Auth.signOut({ global: true })
				.then(data => {
					EventBus.$emit('authState', {
						status: 'signedOut'
					});
				})
				.catch(err => console.error(err));
		},
		formatEmailContent(htmlContent) {
			try {
				// Remove style tags and their contents first
				htmlContent = htmlContent.replace(/<style[^>]*>[\s\S]*?<\/style>/gi, '');
				
				// Check if it's a notification email
				const notificationMatch = htmlContent.match(/Sent Email Notification: (.*?) to (.*?) with message:/);
				if (notificationMatch) {
					const subject = notificationMatch[1];
					const recipient = notificationMatch[2];
					
					// Create temp div to parse the message content
					const div = document.createElement('div');
					div.innerHTML = htmlContent.split('with message:')[1];
					
					// Parse HTML to markdown
					let messageContent = this.htmlToMarkdown(div);

					return `**Email Notification**\n` +
						   `📧 To: \`${recipient}\`\n` +
						   `📑 Subject: ${subject}\n` +
						   `💬 Message:\n${messageContent}`;
				}

				// Handle regular HTML email content
				const div = document.createElement('div');
				div.innerHTML = htmlContent;

				// Extract recipients from mailto links
				const recipients = [];
				const links = div.getElementsByTagName('a');
				for (const link of links) {
					if (link.href && link.href.startsWith('mailto:')) {
						recipients.push(link.href.replace('mailto:', ''));
					}
				}

				// Convert HTML to markdown
				let content = this.htmlToMarkdown(div);

				// Build formatted output
				let output = '';
				if (recipients.length > 0) {
					output += `📧 Recipients: \`${recipients.join(', ')}\`\n`;
				}
				output += content;

				// Truncate if too long
				const maxLength = 500;
				if (output.length > maxLength) {
					output = output.substring(0, maxLength) + '...';
				}

				return output;
			} catch (error) {
				console.error('Error formatting email content:', error);
				return htmlContent; // Return original if parsing fails
			}
		},
		htmlToMarkdown(element) {
			let markdown = '';
			
			// Process child nodes
			for (const node of element.childNodes) {
				if (node.nodeType === Node.TEXT_NODE) {
					// Clean up text content
					let text = node.textContent
						.replace(/{[^}]+}/g, '') // Remove CSS blocks
						.replace(/\.serif\s*{[^}]*}/g, '') // Remove specific serif CSS
						.replace(/\s+/g, ' ') // Normalize whitespace
						.trim();
					
					if (text) markdown += text + ' ';
				} else if (node.nodeType === Node.ELEMENT_NODE) {
					switch (node.tagName.toLowerCase()) {
						case 'p':
							markdown += '\n\n' + this.htmlToMarkdown(node) + '\n';
							break;
						case 'br':
							markdown += '\n';
							break;
						case 'strong':
						case 'b':
							markdown += `**${this.htmlToMarkdown(node)}**`;
							break;
						case 'em':
						case 'i':
							markdown += `_${this.htmlToMarkdown(node)}_`;
							break;
						case 'a':
							const href = node.getAttribute('href');
							if (href && !href.startsWith('mailto:')) {
								markdown += `[${this.htmlToMarkdown(node)}](${href})`;
							} else {
								markdown += this.htmlToMarkdown(node);
							}
							break;
						case 'ul':
							markdown += '\n';
							for (const li of node.children) {
								markdown += `• ${this.htmlToMarkdown(li)}\n`;
							}
							markdown += '\n';
							break;
						case 'ol':
							markdown += '\n';
							Array.from(node.children).forEach((li, i) => {
								markdown += `${i + 1}. ${this.htmlToMarkdown(li)}\n`;
							});
							markdown += '\n';
							break;
						default:
							markdown += this.htmlToMarkdown(node);
					}
				}
			}

			return markdown
				.replace(/\n{3,}/g, '\n\n') // Remove extra newlines
				.trim();
		},
		saveVaultTags(vault) {
			let self = this;
			if (vault && vault._editTagsArray) {
				// Ensure tags are strings and remove empty ones
				vault.tags = vault._editTagsArray.filter(tag => tag && tag.trim()).map(tag => String(tag).trim());
				
				vaultService.mutation("updateVaultSettings", {
					"vault_id": vault.id,
					"org_id": vault.org_id,
					"tags": vault.tags,
					"archived": Boolean(vault.archived) || false,
					"private_mode": Boolean(vault.private_mode) || false,
					"hide_perms": Boolean(vault.hide_perms) || false,
					"isTemplate": Boolean(vault.isTemplate) || false
				}).then(() => {
					self.notification('success', "Portal tags updated successfully.");
				}).catch(error => {
					self.notification('error', "Unable to update portal tags.");
					console.error("GQL updateVaultSettings Error:", error);
				});
			}
		},
		// File Accumulator Methods
		showFileAccumulator() {
			this.fileAccumulator.isVisible = true;
			this.fileAccumulator.isMinimized = false;
			this.fileAccumulator.lastClosedTimestamp = null;
			// Initialize with default values
			this.fileAccumulator.selectedEmails = [...this.uploadEmailAddresses];
		},

		showFileAccumulatorForUploads() {
			// Show accumulator when uploads start
			this.fileAccumulator.isVisible = true;
			this.fileAccumulator.isMinimized = false;
			// DON'T clear lastClosedTimestamp here - only clear it when user manually opens or sends notifications
			// Initialize with default values
			this.fileAccumulator.selectedEmails = [...this.uploadEmailAddresses];
		},

		minimizeFileAccumulator() {
			this.fileAccumulator.isMinimized = true;
		},

		maximizeFileAccumulator() {
			this.fileAccumulator.isMinimized = false;
		},

		
		hideFileAccumulator() {
			this.fileAccumulator.isVisible = false;
			this.fileAccumulator.isMinimized = false;
			this.fileAccumulator.lastClosedTimestamp = Date.now();
		},

		clearFileAccumulator() {
			this.fileAccumulator.recentFiles = [];
			this.fileAccumulator.customMessage = "";
			// Don't automatically hide the popup - let user close it manually
		},

		addToFileAccumulator(file) {
			// Only add if not already in accumulator
			if (!this.fileAccumulator.recentFiles.find(f => f.id === file.id)) {
				const fileAddedTimestamp = Date.now();
				this.fileAccumulator.recentFiles.push({
					id: file.id,
					name: file.name,
					size: file.size,
					uploadTime: new Date(),
					extension: file.extension,
					addedTimestamp: fileAddedTimestamp
				});

				// Show accumulator if auto-show is enabled, files are present, and 
				// either user hasn't closed it or this file was added after they closed it
				const shouldShow = this.fileAccumulator.autoShow && 
					this.fileAccumulator.recentFiles.length > 0 && 
					(!this.fileAccumulator.lastClosedTimestamp || 
					 fileAddedTimestamp > this.fileAccumulator.lastClosedTimestamp);
				
				if (shouldShow) {
					this.showFileAccumulator();
				}
			}
		},

		removeFromFileAccumulator(fileId) {
			this.fileAccumulator.recentFiles = this.fileAccumulator.recentFiles.filter(f => f.id !== fileId);
			// Don't auto-hide the popup when files are removed - let user control visibility
		},

		sendFileAccumulatorNotification() {
			return new Promise((resolve, reject) => {
				let now = new Date();
				
				// Prevent duplicate sends by checking if already sending
				if (this.fileAccumulator.sending) {
					reject("Already sending notification.");
					return;
				}
				
				if (!this.fileAccumulator.selectedEmails || this.fileAccumulator.selectedEmails.length === 0) {
					this.notification("error", "Please select at least one recipient to send the notification.");
					reject("Please select at least one recipient to send the notification.");
					return;
				}

				// Collect all completed files from both upload queue and recent files
				let completedUploadFiles = this.uploadFileQueue.filter(f => f.status === 'done').map(f => ({
					name: f.upload.filename,
					size: f.upload.size || 0
				}));
				
				let allCompletedFiles = [...this.fileAccumulator.recentFiles, ...completedUploadFiles];

				if (allCompletedFiles.length === 0) {
					this.notification("error", "No files to notify about.");
					reject("No files to notify about.");
					return;
				}

				// Set sending flag to prevent duplicates
				this.fileAccumulator.sending = true;

				// Build the file list for the email
				let fileListHtml = '<ul>';
				allCompletedFiles.forEach(file => {
					fileListHtml += `<li><strong>${file.name}</strong></li>`;
				});
				fileListHtml += '</ul>';

				// Build the email message
				let emailMessage = '';
				if (this.fileAccumulator.customMessage) {
						emailMessage += `<p>${this.fileAccumulator.customMessage}</p><br>`;
					}
				emailMessage += fileListHtml + '<br>';
				emailMessage += `<p>Portal: <a href="${window.location.origin}${window.location.pathname}${window.location.search}">${this.vault.name}</a></p>`;

				let toEmails = "admin";
				if (this.cognito.attributes["custom:mutableUserType"] !== "guest" && this.cognito.attributes["custom:mutableOrgId"] === this.vault.org_id) {
					toEmails = this.fileAccumulator.selectedEmails.map(notEm => notEm.email).join(",");
				}

				let defaultSubject = `New files uploaded to ${this.vault.name}`;

				vaultService.mutation("newAuditNotificationAction", {
					action: "custom_upload",
					vault_id: this.vault.id,
					org_id: this.vault.org_id ? this.vault.org_id : '',
					description: `Subject: ${defaultSubject}\n\n${emailMessage}`,
					filename: toEmails,
					action_date: now.getTime().toString()
				}).then(result => {
					this.notification("success", "Upload notification sent successfully!");
					
					// Clear and close the popup after successful send
					this.fileAccumulator.recentFiles = [];
					this.fileAccumulator.customMessage = "";
					this.fileAccumulator.selectedEmails = [];
					this.fileAccumulator.lastClosedTimestamp = null;
					
					// Remove completed files from upload queue
					this.uploadFileQueue = this.uploadFileQueue.filter(f => f.status !== 'done');
					
					// Close the popup
					this.hideFileAccumulator();
					
					// Clear sending flag
					this.fileAccumulator.sending = false;
					
					resolve();
				}).catch(error => {
					this.notification("error", "Unable to send upload notification, please try again.");
					console.log(error);
					
					// Clear sending flag on error
					this.fileAccumulator.sending = false;
					
					reject("Unable to send upload notification, please try again.");
				});
			});
		},

		toggleFileAccumulatorAutoShow() {
			this.fileAccumulator.autoShow = !this.fileAccumulator.autoShow;
			let message = this.fileAccumulator.autoShow ? "File accumulator will now show automatically when files are uploaded." : "File accumulator auto-show has been disabled.";
			this.notification("success", message);
		},

		// Messages Tab Methods
		loadMessagesTab() {
			if (!this.messagesLoaded) {
				this.loadMessages();
			}
		},

		loadMessages() {
			this.messagesLoaded = false;
			this.messagesPage = 1;
			
			vaultService.query("getVaultAuditHistoryById", {
				vault_id: this.vault.id, 
				loadAuditHistory: true
			}, undefined, {vuexCache: false}).then(response => {
				// Filter only email entries from the audit history
				let emailEntries = response.getVaultById.audit_history.filter(entry => 
					entry.action === 'Email'
				);
				
				this.messages = this.processEmailsForMessages(emailEntries);
				this.messagesLoaded = true;
				this.canLoadMoreMessages = emailEntries.length >= this.messagesPerPage;
				
				// Auto-scroll to bottom like a chat app
				this.$nextTick(() => {
					this.scrollToBottomOfMessages();
				});
			}).catch(error => {
				console.error("Failed to load messages:", error);
				this.notification("error", "Failed to load messages. Please try again.");
				this.messagesLoaded = true;
			});
		},

		loadMoreMessages() {
			this.loadingMoreMessages = true;
			this.messagesPage++;
			
			// In a real implementation, you'd want pagination on the server side
			// For now, we'll simulate it by just disabling the load more button
			setTimeout(() => {
				this.loadingMoreMessages = false;
				this.canLoadMoreMessages = false;
			}, 1000);
		},

		scrollToBottomOfMessages() {
			// Scroll to bottom of messages container like a chat app
			if (this.$refs.messagesContainer) {
				this.$refs.messagesContainer.scrollTop = this.$refs.messagesContainer.scrollHeight;
			}
		},

		processEmailsForMessages(emailEntries) {
			return emailEntries.map(entry => {
				// Parse the email data from the description
				let lines = entry.description.split('\n');
				let subject = '';
				let content = '';
				let parseContent = false;
				
				lines.forEach(line => {
					if (line.startsWith('Subject: ')) {
						subject = line.replace('Subject: ', '');
					} else if (parseContent || (!line.startsWith('Subject: ') && line.trim() !== '')) {
						parseContent = true;
						content += line + '\n';
					}
				});

				// Clean up content and process for display
				content = this.processMessageContent(content.trim());
				
				// Extract sender info from available audit fields
				// According to GraphQL schema, only 'username' is available, not 'user_name' or 'user_email'
				let senderName = entry.username || 'Unknown User';
				let senderUserId = entry.user_id || '';
				
				// Improved member/guest detection using user_id instead of email
				let isFromMember = this.isUserTypeMemberById(senderUserId, senderName);
				
				let senderInitials = this.getUserInitials(senderName);

				// Parse timestamp correctly - action_date is stored as string milliseconds
				let actionDate;
				if (entry.action_date) {
					// Convert string timestamp to number, then to Date
					let timestamp = parseInt(entry.action_date, 10);
					actionDate = new Date(timestamp);
				} else {
					actionDate = new Date();
				}

				return {
					id: entry.audit_id || entry.action_date,
					subject: subject,
					content: content,
					senderName: senderName,
					senderUserId: senderUserId,
					senderInitials: senderInitials,
					timestamp: this.formatMessageTimestamp(entry.action_date),
					isFromMember: isFromMember,
					rawEntry: entry,
					sortDate: actionDate // Proper Date object for sorting
				};
			}).sort((a, b) => a.sortDate.getTime() - b.sortDate.getTime()); // Sort by timestamp, oldest first
		},

		processMessageContent(content) {
			if (!content) return '';
			
			let processed = content;
			
			// Remove specific problematic patterns only - be surgical, not aggressive
			processed = processed.replace(/^.*?com with message:\s*/i, '');
			processed = processed.replace(/^.*?has shared.*?with you[:\.]?\s*/i, '');
			
			// Remove specific CSS declarations that are causing issues
			processed = processed.replace(/\.serif\s*\{[^}]*\}/gi, '');
			processed = processed.replace(/font-family\s*:\s*[^;]+;?/gi, '');
			
			// Remove style attributes 
			processed = processed.replace(/style\s*=\s*["'][^"']*["']/gi, '');
			
			// Better asterisk cleanup - remove standalone asterisks and broken bold formatting
			processed = processed.replace(/^\*+\s*/gm, ''); // Remove asterisks at the beginning of lines
			processed = processed.replace(/\s+\*+\s*$/gm, ''); // Remove asterisks at the end of lines
			processed = processed.replace(/^\*+$/gm, ''); // Remove lines that are only asterisks
			processed = processed.replace(/\n\*+\s*\n/g, '\n'); // Remove asterisks between newlines
			processed = processed.replace(/\*+\s*\n\s*\*+/g, ''); // Remove broken bold formatting across lines
			
			// Clean up any extra whitespace
			processed = processed.trim();
			
			// Convert basic HTML tags for better display
			// Replace <br> tags with newlines
			
			processed = processed.replace(/<br\s*\/?>/gi, '\n');
			
			// Convert <p> tags to double newlines
			
			processed = processed.replace(/<\/p>\s*<p[^>]*>/gi, '\n\n');
			processed = processed.replace(/<\/?p[^>]*>/gi, '');
			
			// Convert <ul> and <li> tags for lists
			
			processed = processed.replace(/<ul[^>]*>/gi, '');
			processed = processed.replace(/<\/ul>/gi, '\n');
			processed = processed.replace(/<li[^>]*>/gi, '• ');
			processed = processed.replace(/<\/li>/gi, '\n');
			
			// Convert <strong> and <b> tags to markdown-style bold
			
			processed = processed.replace(/<\/(strong|b)>/gi, '**');
			processed = processed.replace(/<(strong|b)[^>]*>/gi, '**');
			
			// Remove any remaining HTML tags completely
			
			processed = processed.replace(/<[^>]*>/g, '');
			
			// Remove any remaining HTML entities and decode them
			
			processed = processed.replace(/&lt;/g, '<');
			processed = processed.replace(/&gt;/g, '>');
			processed = processed.replace(/&amp;/g, '&');
			processed = processed.replace(/&quot;/g, '"');
			processed = processed.replace(/&#39;/g, "'");
			processed = processed.replace(/&nbsp;/g, ' ');
			
			// Final asterisk cleanup after HTML processing
			processed = processed.replace(/^\*+\s*/gm, ''); // Remove any remaining asterisks at line beginnings
			processed = processed.replace(/\*+\s*$/gm, ''); // Remove any remaining asterisks at line endings
			
			// Collapse multiple spaces/tabs into single spaces
			processed = processed.replace(/[ \t]+/g, ' ');
			
			
			// Collapse multiple newlines (3 or more) into just 2 newlines (one blank line)
			processed = processed.replace(/\n{3,}/g, '\n\n');
			
			// Remove leading/trailing whitespace from each line
			processed = processed.split('\n').map(line => line.trim()).join('\n');
			
			// Final cleanup of multiple consecutive blank lines
			processed = processed.replace(/(\n\s*){3,}/g, '\n\n');
			
			return processed.trim();
		},

		isUserTypeMemberById(userId, username) {
			// Check if the user is a member vs guest using user_id
			if (!userId) {
				return false;
			}
			
			// Check if this is the current user and they are a member/admin
			if (this.cognito && this.cognito.attributes) {
				let currentUserId = this.cognito.attributes.sub;
				let currentUserType = this.cognito.attributes["custom:mutableUserType"];
				
				if (userId === currentUserId && (currentUserType === 'member' || currentUserType === 'admin')) {
					return true;
				}
			}
			
			// Check against vault permissions using user_id
			if (this.vault && this.vault.permissions) {
				let permission = this.vault.permissions.find(p => p.user_id === userId && p._deleted !== 1);
				if (permission) {
					return permission.user_type === 'member';
				}
			}
			
			// Check against organization permissions if available
			if (this.organization && this.organization.permissions) {
				let orgPermission = this.organization.permissions.find(p => p.user_id === userId && p._deleted !== 1);
				if (orgPermission) {
					return true; // Organization members are considered members
				}
			}
			
			return false; // Default to guest if we can't determine
		},

		isUserTypeMember(email, entry) {
			// Check if the email belongs to a team member vs guest
			if (!email) {
				return false;
			}
			
			// Check if this is the current user and they are a member/admin
			if (this.cognito && this.cognito.attributes) {
				let currentUserEmail = this.cognito.attributes.email;
				let currentUserType = this.cognito.attributes["custom:mutableUserType"];
				
				if (email === currentUserEmail && (currentUserType === 'member' || currentUserType === 'admin')) {
					return true;
				}
			}
			
			// Check against vault permissions to determine if user is a member or guest
			if (this.vault && this.vault.permissions) {
				let permission = this.vault.permissions.find(p => p.user_email === email && p._deleted !== 1);
				if (permission) {
					return permission.user_type === 'member';
				}
			}
			
			// Check against organization permissions
			if (this.organization && this.organization.permissions) {
				let orgPermission = this.organization.permissions.find(p => p.user_email === email && p._deleted !== 1);
				if (orgPermission) {
					return true; // Organization members are considered members
				}
			}
			
			return false; // Default to guest if we can't determine
		},

		getUserInitials(name) {
			if (!name) return '?';
			return name.split(' ')
				.map(word => word.charAt(0))
				.join('')
				.toUpperCase()
				.substring(0, 2);
		},

		formatMessageTimestamp(timestamp) {
			if (!timestamp) return '';
			// Always use MM/dd/yyyy hh:mm aa format instead of relative time
			
			// action_date from audit entries is stored as string milliseconds
			let timestampMs;
			if (typeof timestamp === 'string') {
				timestampMs = parseInt(timestamp, 10);
			} else if (typeof timestamp === 'number') {
				timestampMs = timestamp;
			} else {
				return '';
			}
			
			return moment(timestampMs).format("MM/DD/YYYY hh:mm A");
		},

		formatMessageForDisplay(content) {
			if (!content) return '';
			
			// First, completely escape ALL HTML to prevent any leftover code from showing
			let formatted = content
				.replace(/&/g, '&amp;')
				.replace(/</g, '&lt;')
				.replace(/>/g, '&gt;')
				.replace(/"/g, '&quot;')
				.replace(/'/g, '&#39;');
			
			// Now safely convert markdown-style bold (**text**) to HTML bold
			formatted = formatted.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
			
			// Convert line breaks to HTML line breaks for proper display
			formatted = formatted.replace(/\n/g, '<br>');
			
			return formatted;
		}
	}
});
